const it = {
  // Common words and phrases
  common: {
    back: "Indietro",
    search: "Cerca",
    filter: "Filtra",
    clear: "Cancella",
    export: "Esporta",
    currency: "Valuta",
    country: "Paese",
    download: "Scarica",
    loading: "Caricamento...",
    saving: "Salvataggio...",
    save: "Salva",
    save_changes: "Salva modifiche",
    apply: "Applica",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    view: "Visualizza",
    add: "Aggiungi",
    name: "Nome",
    email: "Email",
    password: "Password",
    confirm: "Conferma",
    submit: "Invia",
    error: "Errore",
    success: "Successo",
    warning: "Avviso",
    info: "Info",
    yes: "Si",
    no: "No",
    all: "Tutti",
    none: "Nessuno",
    select: "Seleziona",
    for: "per",
    in: "in",
    showMore: "Mostra di pi\u00F9",
    next: "Avanti",
    previous: "Precedente",
    showLess: "Mostra meno",
    clearFilter: "Cancella filtro",
    searchCountry: "Cerca paesi...",
    page: "Pagina",
    merchant: "Esercente",
    description: "Descrizione",
    account: "Conto",
    type: "Tipo",
    date: "Data",
    amount: "Importo",
    category: "Categoria",
    transactions: "Transazioni",
    total: "Totale",
    actions: "Azioni",
    viewReport: "Visualizza report",
    other: "Altro",
    selectCountries: "Seleziona paesi",
    noCountryFound: "Nessun paese trovato.",
    continue: "Continua",
    or: "oppure",
  },

  // Time related
  time: {
    today: "Oggi",
    yesterday: "Ieri",
    thisWeek: "Questa settimana",
    lastWeek: "Settimana scorsa",
    thisMonth: "Questo mese",
    lastMonth: "Mese scorso",
    thisYear: "Quest'anno",
    lastYear: "Anno scorso",
    custom: "Personalizzato",
    from: "Da",
    to: "A",
    now: "Adesso",
    quarter: "Trimestre",
    year: "Anno",
    month: "Mese",
    period: "Periodo",
    startMonth: "Mese iniziale",
    endMonth: "Mese finale",
    startQuarter: "Trimestre iniziale",
    endQuarter: "Trimestre finale",
    lastQuarter: "Ultimi 90 giorni",
    allTime: "Tutto il periodo",
  },

  // Navigation and menus
  nav: {
    passiveIncome: "Reddito passivo",
    dashboard: "Dashboard",
    transactions: "Transazioni",
    accounts: "Conti",
    categories: "Categorie",
    reports: "Report",
    settings: "Impostazioni",
    users: "Utenti",
    logout: "Esci",
    login: "Accedi",
    register: "Registrati",
    profile: "Profilo",
    preferences: "Preferenze",
    help: "Aiuto",
    support: "Supporto",
    about: "Informazioni",
    currencyRates: "Tassi di cambio",
    financialSummary: "Riepilogo Finanziario",
    portfolioHoldings: "Portafoglio investimenti",
    tagAnalytics: "Analisi per tag",
    equityAnalysis: "Analisi azionaria",
    expenses: "Spese",
    agents: "Bliss Agents",
    importAgent: "Agente di importazione",
    insightAgent: "Insights AI",
    travelAgent: "Agente di viaggio",
    manageAssets: "Gestisci asset",
    assetsLiabilities: "Attivi e passivi",
    transactionReview: "Revisione transazioni",
    subscriptions: "Abbonamenti",
  },

  // Page titles and descriptions
  pages: {
    oauth: {
      consent: {
        title: "Collega {{client}} a Bliss",
        subtitle: "Questa app vuole usare i tuoi dati Bliss tramite il server MCP.",
        signed_in_as: "Accesso effettuato come {{email}}",
        redirect_notice: "Dopo la tua scelta verrai riportato a",
        access_label: "Accesso",
        read_only_description: "Vedere transazioni, portafoglio, analisi e insight. Non può modificare nulla.",
        read_write_description: "Anche ricategorizzare transazioni, gestire le code di revisione e modificare i dati del portafoglio.",
        expiry_label: "La connessione scade dopo",
        no_expiry_warning: "Una connessione senza scadenza continua a funzionare finché non la revochi.",
        footnote: "L'app vede i tuoi dati finanziari decifrati. Puoi revocare la connessione in qualsiasi momento in Impostazioni → Integrazioni.",
        admin_required: "Solo un amministratore dello spazio può collegare app. Chiedi a un amministratore di collegarla.",
        allow: "Consenti",
        deny: "Rifiuta",
        error_title: "Impossibile completare questa connessione",
        error_missing: "Questo link è incompleto. Avvia di nuovo la connessione dalla tua app.",
        error_generic: "Qualcosa è andato storto. Avvia di nuovo la connessione dalla tua app.",
      },
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Panoramica della tua situazione finanziaria",
      summary: "Riepilogo",
      recentTransactions: "Transazioni recenti",
      quickActions: "Azioni rapide",
      insights: "Analisi",
      totalNetWorth: "Patrimonio netto totale",
    },
    accounts: {
      title: "Conti",
      subtitle: "Gestisci i tuoi conti finanziari",
      addAccount: "Aggiungi conto",
      editAccount: "Modifica conto",
      deleteAccount: "Elimina conto",
      accountDetails: "Dettagli conto",
      noAccounts: "Nessun conto trovato",
      hasBeenRemoved: "\u00E8 stato rimosso",
    },
    transactions: {
      title: "Transazioni",
      subtitle: "Visualizza e gestisci le tue transazioni",
      addTransaction: "Aggiungi transazione",
      editTransaction: "Modifica transazione",
      deleteTransaction: "Elimina transazione",
      transactionDetails: "Dettagli transazione",
      noTransactions: "Nessuna transazione trovata",
      noTransactionsFound: "Nessuna transazione trovata",
      tryDifferentFilters: "Prova a modificare i filtri per trovare ci\u00F2 che cerchi.",
      filter: "Filtra transazioni",
      import: "Importa transazioni",
      export: "Esporta transazioni",
      allAccounts: "Tutti i conti",
      allGroups: "Tutti i gruppi",
      allCategories: "Tutte le categorie",
      categoryGroup: "Gruppo categoria",
      exportCsv: "Esporta CSV",
      importCsv: "Importa CSV",
      exportComplete: "Esportazione completata",
      csvDownloaded: "CSV scaricato con successo",
      exportFailed: "Esportazione fallita",
      exporting: "Esportazione...",
      exportTransactions: "Esporta transazioni",
      exportDescription: "Scegli quali transazioni esportare",
      currentFilters: "{{count}} transazioni corrispondenti ai filtri attuali",
      allTransactions: "Tutte le transazioni",
      exportingTransactions: "Esportazione delle transazioni in corso...",
      exportingNote: "Potrebbe richiedere un momento. Non chiudere questa finestra.",
      startDate: "Data inizio",
      endDate: "Data fine",
      pickDate: "Seleziona data",
      editTransactionDescription: "Modifica i dettagli di questa transazione.",
      addTransactionDescription: "Compila i dettagli per aggiungere una nuova transazione.",
    },
    categories: {
      title: "Categorie",
      subtitle: "Gestisci le categorie delle transazioni",
      addCategory: "Aggiungi categoria",
      editCategory: "Modifica categoria",
      renameCategory: "Rinomina categoria",
      deleteCategory: "Elimina categoria",
      categoryDetails: "Dettagli categoria",
      noCategories: "Nessuna categoria trovata",
      hasBeenRemoved: "\u00E8 stata rimossa",
      renameDescription: "Le categorie predefinite non possono essere spostate in un tipo o gruppo diverso. Puoi aggiornare il nome e l'icona.",
      addNewDescription: "Compila i dettagli per creare una nuova categoria personalizzata.",
      updateDetails: "Aggiorna i dettagli della categoria qui sotto.",
      customCategories: "Categorie personalizzate",
      customEmpty: "Nessuna categoria personalizzata. Aggiungine una quando quelle predefinite non sono adatte.",
      addToType: "+ Aggiungi categoria {{type}}",
      filterByGroup: "Filtra per gruppo",
      empty: {
        title: "Nessuna categoria trovata",
        description: "Crea la tua prima categoria per iniziare.",
      },
      noMatch: {
        title: "Nessun risultato trovato",
        description: "Prova a modificare la tua ricerca.",
      },
    },
    reports: {
      title: "Report",
      subtitle: "Seleziona un tipo di report per generare analisi finanziarie dettagliate",
      financialSummary: {
        title: "Riepilogo Finanziario",
        description: "Visualizza entrate e spese in diversi periodi"
      },
      expenses: {
        title: "Monitoraggio spese",
        description: "Analizza i modelli di spesa per categoria"
      },
      portfolio: {
        title: "Portafoglio investimenti",
        description: "Visualizza e analizza il tuo portafoglio di investimenti"
      },
      recentReports: {
        title: "Report recenti",
        description: "I tuoi report generati di recente",
        empty: "Nessun report recente trovato.",
        hint: "I report che generi appariranno qui per un accesso rapido."
      }
    },
    currencyRates: {
      title: "Tassi di cambio",
      subtitle: "Monitora e gestisci i tassi di cambio",
      baseCurrency: "Valuta base",
      targetCurrency: "Valuta di destinazione",
      currentRate: "Tasso attuale",
      historicalRates: "Tassi storici",
      updateRate: "Aggiorna tasso",
    },
    financialSummary: {
      title: "Riepilogo Finanziario",
      subtitle: "Visualizza e analizza le tue entrate e spese",
      statement: "Prospetto",
      trend: "Tendenza mensile",
      breakdown: "Dettaglio di entrate e uscite",
      chartDescription: "Ripartizione mensile di entrate, spese e risparmio",
      downloadStatement: "Scarica prospetto completo",
      netIncome: "Reddito netto",
      netSavings: "Risparmio Netto",
      totalRevenue: "Ricavi totali",
      totalExpenses: "Spese totali",
      savingsRate: "Tasso di Risparmio",
      topExpense: "Spesa principale",
      discretionaryIncome: "Reddito Discrezionale",
      savingsCapacity: "Capacità di Risparmio",
      otherActivity: "Altra Attività",
    },
    portfolio: {
      title: "Portafoglio investimenti",
      description: "Monitora e analizza il tuo portafoglio per classe di asset",
      subtitle: "Monitora e analizza il tuo portafoglio per classe di asset",
      totalValue: "Valore totale del portafoglio",
      totalHoldings: "Su {{count}} posizioni",
      gainLoss: "Guadagno/Perdita totale",
      overallReturn: "{{value}}% rendimento complessivo",
      assetBreakdown: "Ripartizione per classe di asset",
      holdings: "Lista posizioni",
      allocation: "Allocazione degli asset",
      performance: "Performance",
      holdingsDescription: "I tuoi investimenti raggruppati per tipo di asset",
      allocationDescription: "Distribuzione del portafoglio per tipo di asset",
      performanceDescription: "Confronto dei guadagni e delle perdite tra diversi tipi di asset",
      search: "Cerca posizioni...",
      assetAndType: "Asset e tipo",
      symbolId: "Simbolo/ID",
      qtyUnits: "Qt\u00E0/Unit\u00E0",
      currentPrice: "Prezzo attuale",
      marketValue: "Valore di mercato",
      gainLossValue: "Guadagno/Perdita",
      percentReturn: "% Rendimento"
    },
    expenses: {
      title: "Monitoraggio spese",
      description: "Analizza i tuoi modelli di spesa per categoria",
      selectCategoryType: "Seleziona il tipo di categoria",
      countriesSelected: "{{count}} paesi selezionati",
      includeCredits: {
        label: "Includi crediti",
        tooltip: "Attivo: i crediti nelle categorie di spesa (rimborsi, la quota di un coinquilino, indennizzi assicurativi) vengono sottratti dai debiti. Disattivo: mostra solo i debiti."
      },
      basis: {
        net: "debiti − crediti",
        debitOnly: "solo debiti"
      },
      timeFrame: {
        label: "Periodo",
        month: "Mese",
        quarter: "Trimestre",
        year: "Anno"
      },
      export: "Esporta",
      metrics: {
        totalExpenses: "Spese totali",
        averageMonthly: "Media mensile",
        highestCategory: "Categoria principale",
        monthlyAverage: "Media mensile"
      },
      breakdown: {
        title: "Dettaglio spese",
        description: "Visualizza le spese per categoria",
        tabs: {
          byCategory: "Per categoria",
          monthlyTrends: "Tendenze mensili",
          detailedList: "Lista dettagliata"
        },
        topCategories: "Categorie di spesa principali",
        netCredits: "Crediti netti",
        netCreditsCaption: "Il totale include {{amount}} di crediti netti",
        noNetSpend: "Nessuna spesa netta in questo periodo",
        trendChart: {
          movingAverageSuffix: " (media 6 mesi)"
        },
        comingSoon: {
          trends: "La vista delle tendenze mensili sar\u00E0 disponibile a breve.",
          details: "La vista dettagliata delle spese sar\u00E0 disponibile a breve."
        },
        details: {
          emptyTitle: "Seleziona una categoria da esplorare",
          emptyDescription: "Clicca su una fetta del grafico a torta o su una riga della categoria per vedere le singole transazioni.",
          goToCategories: "Vai a Per categoria",
          capNotice: "Mostrate le prime 1.000 transazioni; i totali potrebbero essere incompleti",
        }
      }
    },
    settings: {
      title: "Impostazioni account",
      description: "Gestisci le preferenze e le impostazioni del tuo account",
      language: "Lingua",
      error_loading_reference_data: "Impossibile caricare i dati di riferimento. Aggiorna la pagina.",
      error_saving_no_id: "Impossibile trovare il tuo ID utente per salvare le impostazioni.",
      error_saving_generic: "Si \u00E8 verificato un errore sconosciuto durante il salvataggio.",
      success_saving: "Le impostazioni sono state salvate con successo.",
      tabs: {
        general: "Generale",
        countries_currencies: "Paesi e valute",
        banks: "Banche",
        connections: "Connessioni",
        integrations: "Integrazioni",
        ai_classification: "Classificazione IA",
        maintenance: "Manutenzione",
        admin_section: "Amministrazione",
        processing: "Elaborazioni",
        bank_sync: "Sincronizzazione bancaria",
      },
      general: {
        title: "Impostazioni generali",
        description: "Configura le impostazioni generali del tuo tenant",
        tenant_name_label: "Nome tenant",
        tenant_name_description: "Questo \u00E8 il nome della tua organizzazione o del tuo profilo finanziario personale.",
        user_management_label: "Gestione utenti",
        user_management_button: "Gestisci utenti",
        user_management_description: "Gestisci gli utenti con accesso al tuo account tenant.",
        sign_out_others: {
          label: "Altri dispositivi",
          description: "Esci ovunque tranne che su questo dispositivo. Gli altri browser e le app installate dovranno accedere di nuovo.",
          button: "Esci da tutti gli altri dispositivi",
          confirm_title: "Uscire da tutti gli altri dispositivi?",
          confirm_description: "Tutti gli altri browser e le app installate collegati al tuo account verranno disconnessi alla prossima richiesta. Questo dispositivo resta connesso.",
          confirm: "Disconnetti gli altri",
          success: "Gli altri dispositivi sono stati disconnessi.",
          error: "Impossibile disconnettere gli altri dispositivi. Riprova.",
        },
      },
      countries: {
        title: "Paesi",
        description: "Paesi in cui hai attivit\u00E0 finanziarie",
        selected_label: "Paesi selezionati",
        available_label: "Paesi disponibili",
        none_selected: "Nessun paese selezionato"
      },
      currencies: {
        title: "Valute",
        description: "Valute utilizzate nelle tue transazioni",
        selected_label: "Valute selezionate",
        available_label: "Valute disponibili",
        none_selected: "Nessuna valuta selezionata"
      },
      banks: {
        title: "Impostazioni banche",
        description: "Gestisci le banche utilizzate nelle tue attivit\u00E0 finanziarie",
        selected_label: "Le tue banche",
        available_label: "Banche disponibili",
        none_selected: "Nessuna banca selezionata"
      },
      connections: {
        title: "Connessioni Plaid",
        description: "Gestisci le connessioni bancarie collegate e il loro stato di sincronizzazione",
        no_connections: "Nessuna connessione bancaria. Usa 'Collega banca' per collegare il tuo primo conto.",
        status_active: "Attivo",
        status_login_required: "Accesso richiesto",
        status_error: "Errore",
        status_revoked: "Revocato",
        status_pending: "In attesa",
        last_sync: "Ultima sincronizzazione",
        never_synced: "Mai sincronizzato",
        error_code: "Errore",
        reconnect: "Riconnetti",
        reconnect_description: "Ri-autenticati con la tua connessione bancaria per riprendere la sincronizzazione.",
        connection_warning: "Una o pi\u00F9 connessioni bancarie richiedono attenzione.",
        accounts_linked: "conti collegati",
      },
      integrations: {
        title: "Integrazioni e token API",
        description: "Consenti ad agenti IA, script e altri sistemi di usare l'API di Bliss. Ogni integrazione ha i propri token, revocabili in qualsiasi momento.",
        create: "Nuova integrazione",
        create_title: "Nuova integrazione",
        add_key_title: "Aggiungi una chiave",
        rename_title: "Rinomina integrazione",
        empty: "Nessuna integrazione. Creane una per collegare un agente IA o un altro sistema.",
        loading_error: "Impossibile caricare le integrazioni.",
        acting_note: "Le richieste con token agiscono per tuo conto, entro il livello di accesso scelto. Se il tuo utente viene eliminato, le tue integrazioni vengono revocate.",
        security_note: "Chiunque possieda un token può vedere i tuoi dati finanziari decifrati. Trattalo come la password della tua banca.",
        access_read_only: "Sola lettura",
        access_read_write: "Lettura e scrittura",
        access_read_only_description: "Può leggere transazioni, portafoglio, analisi e insight. Non può modificare nulla.",
        access_read_write_description: "Può anche creare e modificare transazioni, tag e importazioni, e gestire la coda di revisione Plaid. Non può gestire conti, categorie, utenti, connessioni bancarie né impostazioni.",
        status_active: "Attiva",
        status_revoked: "Revocata",
        status_expired: "Scaduta",
        keys_count: "{{count}} chiavi attive su {{total}}",
        last_used: "Ultimo utilizzo",
        never_used: "Mai",
        expires: "Scade",
        no_expiry: "Nessuna scadenza",
        add_key: "Aggiungi chiave",
        revoke_key: "Revoca",
        revoke_integration: "Revoca integrazione",
        rename: "Rinomina",
        show_keys: "Chiavi",
        hide_keys: "Nascondi chiavi",
        form: {
          name_label: "Nome",
          name_placeholder: "es. Agente Claude",
          name_required: "Inserisci un nome.",
          description_label: "Descrizione (facoltativa)",
          access_label: "Livello di accesso",
          access_fixed: "Il livello di accesso non può essere modificato in seguito. Per cambiarlo, crea una nuova integrazione.",
          key_name_label: "Nome della chiave (facoltativo)",
          key_name_placeholder: "es. Portatile",
          expiry_label: "La chiave scade dopo",
          expiry_30: "30 giorni",
          expiry_90: "90 giorni",
          expiry_365: "1 anno",
          expiry_never: "Mai",
          no_expiry_warning: "Una chiave senza scadenza continua a funzionare finché non la revochi.",
          create_submit: "Crea integrazione",
          add_key_submit: "Crea chiave",
          save: "Salva",
          cancel: "Annulla",
        },
        reveal: {
          title: "Copia il tuo token",
          subtitle: "Usalo come token Bearer nell'intestazione Authorization.",
          warning: "Questo token non verrà più mostrato. Conservalo in un luogo sicuro, ad esempio un gestore di password.",
          copy: "Copia",
          copied: "Copiato",
          example: "Richiesta di esempio",
          done: "Fatto",
        },
        mcp: {
          title: "Usa con Claude (MCP)",
          description: "Collega Claude Code o un altro client MCP con questa chiave. Vede gli stessi dati consentiti dalla chiave: le chiavi di sola lettura possono solo leggere.",
          url_label: "URL del server MCP:",
          copy_command: "Copia comando",
        },
        oauth: {
          badge: "Connessa tramite OAuth · {{client}}",
          expires: "La connessione scade il {{date}}",
          no_expiry: "La connessione non scade mai",
        },
        confirm: {
          revoke_key_title: "Revocare questa chiave?",
          revoke_key_description: "Tutto ciò che usa questa chiave smetterà di funzionare alla richiesta successiva. Le altre chiavi dell'integrazione continuano a funzionare.",
          revoke_integration_title: "Revocare questa integrazione?",
          revoke_integration_description: "Tutte le sue chiavi smettono di funzionare immediatamente. L'operazione è irreversibile.",
          confirm_revoke: "Revoca",
        },
        toast: {
          created: "Integrazione creata",
          key_created: "Chiave creata",
          key_revoked: "Chiave revocata",
          revoked: "Integrazione revocata",
          renamed: "Integrazione aggiornata",
          error: "Qualcosa è andato storto. Riprova.",
        },
      },
    },
    users: {
      title: "Utenti",
      subtitle: "Gestisci gli account utente e i permessi",
      addUser: "Aggiungi utente",
      editUser: "Modifica utente",
      deleteUser: "Elimina utente",
      userDetails: "Dettagli utente",
      noUsers: "Nessun utente trovato",
      roles: "Ruoli e permessi",
    },
    notFound: {
      title: "Pagina non trovata",
      subtitle: "La pagina che stai cercando non esiste",
      goBack: "Torna alla pagina principale",
    },
    login: {
      confirm_identity: {
        title: "Conferma che sei tu",
        description: "Per la tua sicurezza, conferma la tua identità per continuare. È necessario quando l'ultimo accesso risale a più di 15 minuti fa.",
        password_label: "Password",
        confirm: "Conferma",
        google: "Continua con Google",
        divider: "oppure",
        wrong_password: "Password errata. Riprova.",
        error: "Impossibile confermare la tua identità. Riprova.",
        no_method: "Questo account non può confermare la propria identità qui. Esci, accedi di nuovo e riprova.",
      },
      title: "Accedi",
      subtitle: "Accedi al tuo account",
      noAccount: "Non hai un account?",
      signUp: "Registrati",
      rememberMe: "Ricordami",
    },
    agents: {
      title: "Bliss Agents",
      subtitle: "Assistenti finanziari basati su intelligenza artificiale",
    },
    importAgent: {
      title: "Agente di importazione",
      subtitle: "Importa ed elabora dati finanziari da varie fonti",
      description: "Carica e categorizza automaticamente le transazioni da estratti conto CSV/PDF",
      dropzone: "Trascina i file qui o clicca per sfogliare",
      processing: "Elaborazione dei tuoi documenti",
      success: "Importazione completata",
      failed: "Importazione fallita",
      supportedFormats: "Formati supportati: CSV, PDF, Excel",
      parseOptions: "Opzioni di analisi",
      mapColumns: "Mappa colonne",
      preview: "Anteprima dati",
      import: "Importa dati",
    },
    insightAgent: {
      title: "Agente di analisi",
      subtitle: "Ottieni analisi e raccomandazioni finanziarie personalizzate",
      description: "Analizza i tuoi modelli di spesa e ricevi consigli finanziari su misura",
      generating: "Generazione analisi",
      noData: "Servono pi\u00F9 dati sulle transazioni per generare le analisi",
      categories: "Analisi per categoria",
      trends: "Tendenze di spesa",
      recommendations: "Raccomandazioni",
      savingOpportunities: "Opportunit\u00E0 di risparmio",
      budgetSuggestions: "Suggerimenti di budget",
    },
    travelAgent: {
      title: "Agente di viaggio",
      subtitle: "Gestisci le spese e i budget di viaggio",
      description: "Pianifica viaggi, monitora le spese e ottimizza la spesa di viaggio",
      upcoming: "Viaggi futuri",
      past: "Viaggi passati",
      expenses: "Spese di viaggio",
      currency: "Conversione valuta",
      planning: "Pianificazione viaggio",
      budgeting: "Budget di viaggio",
      addTrip: "Aggiungi viaggio",
      editTrip: "Modifica viaggio",
    },
    comingSoon: {
      title: "In arrivo",
      subtitle: "Questa funzionalit\u00E0 \u00E8 in fase di sviluppo",
      description: "Stiamo lavorando per portarti questa funzionalit\u00E0. Torna a trovarci presto!",
      backToHome: "Torna alla Dashboard",
    },
    manualUpdates: {
      title: "Attivi e passivi",
      subtitle: "Gestisci i prezzi degli asset e le condizioni del debito",
      assetsNeedingUpdate: "Asset che necessitano aggiornamento",
      liabilities: "Passivit\u00E0",
      noAssetsNeedUpdate: "Tutti gli asset sono aggiornati.",
      noLiabilities: "Nessuna passivit\u00E0 trovata.",
      lastUpdated: "Ultimo aggiornamento",
      daysAgo: "{{count}} giorni fa",
      updatePrice: "Aggiorna prezzo",
      editTerms: "Modifica condizioni",
      errorLoading: "Impossibile caricare i dati degli asset. Riprova pi\u00F9 tardi.",
    },
    profile: {
      title: "Profilo",
      subtitle: "Gestisci le tue informazioni personali",
    },
  },

  // Form fields and validation
  forms: {
    required: "Questo campo \u00E8 obbligatorio",
    invalidEmail: "Inserisci un indirizzo email valido",
    passwordLength: "La password deve essere di almeno 8 caratteri",
    passwordMismatch: "Le password non corrispondono",
    invalidAmount: "Inserisci un importo valido",
    invalidDate: "Inserisci una data valida",
    maxLength: "Lunghezza massima superata",
    minLength: "Lunghezza minima richiesta",
    selectOption: "Seleziona un'opzione",
    invalidInput: "Input non valido",
  },

  // Dashboard cards and widgets
  dashboard: {
    totalBalance: "Saldo totale",
    income: "Entrate",
    expenses: "Spese",
    savings: "Risparmi",
    budget: "Budget",
    recentTransactions: "Transazioni recenti",
    cashFlow: "Flusso di cassa",
    netWorth: "Patrimonio netto",
    spendingByCategory: "Spese correnti per categoria",
    topCategories: "Categorie principali",
    monthlyComparison: "Confronto mensile",
    viewAll: "Vedi tutto",
    viewMore: "Vedi altro",
    seeAll: "Vedi tutto",
    welcome: "Bentornato, {{name}}",
    quickActions: "Azioni rapide",
    commonTasks: "Operazioni comuni",
    syncedAccounts: "Conti sincronizzati",
    connected: "collegati",
    allCurrent: "tutti aggiornati",
    noAccountsConnected: "Nessun conto collegato",
    connectMoreAccounts: "Collega altri conti",
    allConnectedAccounts: "Tutti i conti collegati",
    noTransactionsYet: "Nessuna transazione ancora",
    viewAllTransactions: "Vedi tutte le transazioni",
    live: "Live",
    actionNeeded: "Azione richiesta",
  },

  // Charts and graphs
  charts: {
    period: "Periodo",
    value: "Valore",
    change: "Variazione",
    percentage: "Percentuale",
    currency: "Valuta",
    category: "Categoria",
    amount: "Importo",
    date: "Data",
    trend: "Tendenza",
    average: "Media",
    total: "Totale",
    count: "Conteggio",
    min: "Minimo",
    max: "Massimo",
    distribution: "Distribuzione",
    comparison: "Confronto",
  },

  // Asset Types
  assetTypes: {
    Equity: {
      name: "Azioni",
      description: "Azioni, ETF e altri titoli azionari"
    },
    Crypto: {
      name: "Crypto",
      description: "Bitcoin, Ethereum e altre criptovalute"
    },
    RealEstate: {
      name: "Immobili",
      description: "Propriet\u00E0 residenziali e commerciali"
    },
    Bonds: {
      name: "Obbligazioni",
      description: "Obbligazioni governative e societarie"
    },
    PensionPlan: {
      name: "Piano pensionistico",
      description: "Piani pensionistici e previdenziali"
    },
    Stocks: {
      name: "Azioni",
      description: "Azioni di singole societ\u00E0"
    },
    Funds: {
      name: "Fondi",
      description: "Fondi comuni e fondi di investimento"
    },
    ETFs: {
      name: "ETF",
      description: "Fondi negoziati in borsa"
    },
    Cash: {
      name: "Liquidit\u00E0",
      description: "Liquidit\u00E0 e strumenti equivalenti"
    },
    Collectible: {
      name: "Collezione",
      description: "Arte, oggetti da collezione e altri beni unici"
    },
    Vehicle: {
      name: "Veicolo",
      description: "Auto, barche e altri veicoli"
    },
    Other: {
      name: "Altro",
      description: "Altri asset diversi"
    }
  },

  // Transaction types and categories
  transactions: {
    income: "Entrata",
    expense: "Spesa",
    transfer: "Trasferimento",
    investment: "Investimento",
    withdrawal: "Prelievo",
    deposit: "Deposito",
    payment: "Pagamento",
    refund: "Rimborso",
    fee: "Commissione",
    tax: "Tassa",
    dividend: "Dividendo",
    interest: "Interesse",
    sale: "Vendita",
    purchase: "Acquisto",
    other: "Altro",
    // Transaction categories
    housing: "Abitazione",
    food: "Alimentari",
    transportation: "Trasporti",
    utilities: "Utenze",
    healthcare: "Sanit\u00E0",
    personal: "Personale",
    entertainment: "Intrattenimento",
    education: "Istruzione",
    investments: "Investimenti",
    ventures: "Imprese",
  },

  // Financial Summary specific
  financialSummary: {
    revenue: "Ricavi",
    assetTransfer: "Trasferimento asset",
    housingUtilities: "Abitazione e utenze",
    livingExpenses: "Spese correnti",
    personalDevelopment: "Sviluppo personale",
    investments: "Investimenti",
    housing: "Abitazione",
    maintenance: "Manutenzione",
    utilities: "Utenze",
    eatingOut: "Mangiare fuori",
    eatingIn: "Mangiare a casa",
    healthBeauty: "Salute e bellezza",
    shopping: "Shopping",
    entertainment: "Intrattenimento",
    travel: "Viaggi",
    education: "Istruzione",
    skills: "Competenze",
    international: "Internazionale",
    domestic: "Nazionale",
    laborIncome: "Reddito da lavoro",
    taxes: "Tasse",
    ventures: "Imprese",
    angelInvestments: "Investimenti angel",
    variableIncome: "Reddito variabile",
    gambling: "Gioco d'azzardo",
    margin: "margine",
    netIncome: 'Reddito netto',
    discretionaryIncome: 'Reddito Discrezionale',
    savingsCapacity: 'Capacità di Risparmio',
    netSavings: 'Risparmio Netto',
    otherActivity: 'Altra Attività',
    netInvested: "Investimento netto",
    netInvestedTooltip: "Denaro destinato agli investimenti meno il denaro prelevato (vendite, prelievi). Un valore positivo significa che hai investito più di quanto hai prelevato. Non è un guadagno né una perdita.",
    netDebtRepaid: "Debito netto rimborsato",
    netDebtRepaidTooltip: "Debito rimborsato meno i nuovi prestiti (ad esempio, un prestito accreditato dalla tua banca). Un valore positivo significa che hai ridotto il tuo debito.",
    quarters: {
      q1: "T1",
      q2: "T2",
      q3: "T3",
      q4: "T4",
    },
  },

  // UI elements
  ui: {
    darkMode: "Modalit\u00E0 scura",
    lightMode: "Modalit\u00E0 chiara",
    systemMode: "Modalit\u00E0 sistema",
    close: "Chiudi",
    open: "Apri",
    collapse: "Comprimi",
    expand: "Espandi",
    refresh: "Aggiorna",
    retry: "Riprova",
    rename: "Rinomina",
    edit: "Modifica",
    delete: "Elimina",
    deleting: "Eliminazione...",
    cancel: "Annulla",
    saveChanges: "Salva modifiche",
    clearFilters: "Cancella filtri",
    dialog: {
      deleteTitle: "Elimina {{entity}}",
      deleteConfirmation: "Sei sicuro di voler eliminare \"{{name}}\"? Questa azione non pu\u00F2 essere annullata.",
    },
    entity: {
      category: "Categoria",
      account: "Conto",
    },
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    warning: "Avviso",
    info: "Info",
    notification: "Notifica",
    alert: "Avviso",
    dialogElement: "Finestra di dialogo",
    modal: "Modale",
    drawer: "Pannello",
    toast: "Notifica",
    tooltipElement: "Suggerimento",
    badge: "Badge",
    avatar: "Avatar",
    icon: "Icona",
    button: "Pulsante",
    input: "Campo di input",
    select: "Seleziona",
    checkbox: "Casella di controllo",
    radio: "Pulsante radio",
    toggle: "Interruttore",
    slider: "Cursore",
    range: "Intervallo",
    datepicker: "Selettore data",
    timepicker: "Selettore orario",
    colorpicker: "Selettore colore",
    filepicker: "Selettore file",
    pagination: "Paginazione",
    table: "Tabella",
    list: "Lista",
    card: "Scheda",
    tabs: "Schede",
    accordion: "Fisarmonica",
    menu: "Menu",
    dropdown: "Menu a tendina",
    popover: "Popover",
    breadcrumb: "Percorso di navigazione",
    navigation: "Navigazione",
    sidebar: "Barra laterale",
    header: "Intestazione",
    footer: "Pi\u00E8 di pagina",
    content: "Contenuto",
    layout: "Layout",
    gridLayout: "Griglia",
    column: "Colonna",
    row: "Riga",
    section: "Sezione",
    container: "Contenitore",
    wrapper: "Wrapper",
    box: "Box",
    flexbox: "Flexbox",
    stack: "Stack",
    group: "Gruppo",
    divider: "Divisore",
    spacer: "Spaziatore",
    separator: "Separatore",
    spinner: "Indicatore di caricamento",
    progress: "Progresso",
    skeleton: "Scheletro",
    placeholder: "Segnaposto",
    empty: "Vuoto",
    fallback: "Fallback",
    errorState: "Errore",
    successState: "Successo",
    warningState: "Avviso",
    infoState: "Info",
    across: "In totale",
    upgradeToPro: "Passa a Pro",
    upgradeDescription: "Ottieni analisi e funzionalit\u00E0 avanzate",
    upgradeNow: "Aggiorna ora",
  },

  // Notifications and alerts
  notifications: {
    success: {
      saved: "Salvato con successo!",
      created: "Creato con successo!",
      updated: "Aggiornato con successo!",
      deleted: "Eliminato con successo!",
      imported: "Importato con successo!",
      exported: "Esportato con successo!",
      uploaded: "Caricato con successo!",
      downloaded: "Scaricato con successo!",
      sent: "Inviato con successo!",
      submitted: "Inviato con successo!",
    },
    error: {
      title: "Errore",
      general: "Si \u00E8 verificato un errore. Riprova.",
      generic: "Si \u00E8 verificato un errore. Riprova.",
      notFound: "Risorsa non trovata.",
      unauthorized: "Accesso non autorizzato.",
      forbidden: "Accesso negato.",
      validation: "Errore di validazione. Controlla i dati inseriti.",
      server: "Errore del server. Riprova pi\u00F9 tardi.",
      network: "Errore di rete. Controlla la connessione.",
      timeout: "Richiesta scaduta. Riprova.",
      conflict: "Errore di conflitto. La risorsa esiste gi\u00E0.",
      badRequest: "Richiesta non valida. Controlla i dati inseriti.",
      unavailable: "Servizio non disponibile. Riprova pi\u00F9 tardi.",
      tooManyRequests: "Troppe richieste. Riprova pi\u00F9 tardi.",
      deleteCategory: "Impossibile eliminare la categoria. Riprova.",
    },
    warning: {
      unsavedChanges: "Hai modifiche non salvate. Sei sicuro di voler uscire?",
      deleteConfirmation: "Sei sicuro di voler eliminare questo elemento?",
      limitReached: "Hai raggiunto il limite.",
      lowBalance: "Il tuo saldo \u00E8 basso.",
      expiringSoon: "In scadenza.",
    },
    info: {
      noResults: "Nessun risultato trovato.",
      empty: "Nessun elemento da mostrare.",
      loading: "Caricamento...",
      processingRequest: "Elaborazione della richiesta...",
      newVersion: "\u00C8 disponibile una nuova versione.",
      comingSoon: "In arrivo!",
      maintenance: "Manutenzione programmata.",
    },
    center: {
      title: "Notifiche",
      allCaughtUp: "Tutto aggiornato",
    },
  },

  accountForm: {
    accountName: "Nome conto",
    accountNumber: "Numero conto",
    bank: "Banca / Istituto",
    owners: "Intestatari",
    currency: "Valuta",
    country: "Paese",
    accountCreated: "Conto creato",
    accountCreatedSuccess: "{{name}} \u00E8 stato aggiunto ai tuoi conti.",
    accountUpdated: "Conto aggiornato",
    accountUpdatedSuccess: "Il conto \u00E8 stato aggiornato con successo.",
    createAccount: "Crea conto",
    updateAccount: "Aggiorna conto",
    createError: "Impossibile creare il conto. Riprova.",
    updateError: "Impossibile aggiornare il conto. Riprova.",
    selectBank: "Seleziona una banca",
    selectCurrency: "Seleziona una valuta",
    selectCountry: "Seleziona un paese",
    addBank: "Aggiungi una nuova banca",
    addBankError: "Impossibile aggiungere la banca. Riprova.",
  },
  addBankDialog: {
    title: "Aggiungi una nuova banca",
    description: "Inserisci il nome della banca che vuoi aggiungere.",
    nameLabel: "Nome della banca",
    namePlaceholder: "es. Chase, Monzo, Revolut",
    validationError: "Il nome della banca deve contenere tra 2 e 100 caratteri.",
  },
  categoryForm: {
    name: "Nome categoria",
    type: "Tipo",
    group: "Gruppo",
    categoryCreated: "Categoria creata",
    categoryCreatedSuccess: "{{name}} \u00E8 stata aggiunta alle tue categorie.",
    categoryUpdated: "Categoria aggiornata",
    categoryUpdatedSuccess: "La categoria \u00E8 stata aggiornata con successo.",
    createCategory: "Crea categoria",
    updateCategory: "Aggiorna categoria",
    createError: "Impossibile creare la categoria. Riprova.",
    updateError: "Impossibile aggiornare la categoria. Riprova.",
  },
  transactionForm: {
    date: "Data",
    transactionType: "Tipo di transazione",
    description: "Descrizione",
    amount: "Importo",
    fromAccount: "Dal conto",
    account: "Conto",
    toAccount: "Al conto",
    category: "Categoria",
    notes: "Note (Facoltativo)",
    transactionCreated: "Transazione creata",
    transactionCreatedSuccess: "La nuova transazione \u00E8 stata registrata.",
    transactionUpdated: "Transazione aggiornata",
    transactionUpdatedSuccess: "La transazione \u00E8 stata aggiornata con successo.",
    createTransaction: "Crea transazione",
    updateTransaction: "Aggiorna transazione",
    createError: "Impossibile creare la transazione. Riprova.",
    updateError: "Impossibile aggiornare la transazione. Riprova.",
  },
  userForm: {
    email: "Email",
    userCreated: "Utente creato",
    userCreatedSuccess: "{{email}} \u00E8 stato invitato nel tuo team.",
    userUpdated: "Utente aggiornato",
    userUpdatedSuccess: "L'utente \u00E8 stato aggiornato con successo.",
    inviteUser: "Invita utente",
    updateUser: "Aggiorna utente",
    createError: "Impossibile creare l'utente. Riprova.",
    updateError: "Impossibile aggiornare l'utente. Riprova.",
  },

  // Default category translations (keyed by defaultCategoryCode)
  defaultCategories: {
    names: {
      OPERATING_CASH: "Liquidit\u00E0 operativa",
      STOCKS: "Azioni",
      INVESTMENT_FUNDS: "Fondi",
      ETFS: "ETF",
      COPY_TRADING: "Copy Trading",
      PENSION_PLAN: "Piano pensionistico",
      GOVERNMENT_BONDS: "Titoli di Stato",
      CORPORATE_BONDS: "Obbligazioni societarie",
      CRYPTO: "Crypto",
      REAL_ESTATE: "Immobili",
      COLLECTIBLE: "Collezione",
      VEHICLE: "Veicolo",
      COMMODITIES: "Materie prime",
      PRIVATE_EQUITY: "Private Equity",
      MORTGAGE: "Mutuo",
      CREDIT_CARD_DEBT: "Debito carta di credito",
      ALLOWANCE: "Indennit\u00E0",
      RENT_INCOME: "Reddito da affitto",
      SALARY: "Stipendio",
      FREELANCE_INCOME: "Reddito da Lavoro Autonomo",
      BONUS: "Bonus",
      COMMISSION: "Commissione",
      GOVERNMENT_WELFARE: "Assistenza pubblica",
      TAXES: "Tasse",
      TAX_REFUND: "Rimborso Fiscale",
      DIVIDENDS: "Dividendi",
      BOND_INCOME: "Reddito obbligazionario",
      INTEREST_INCOME: "Reddito da interessi",
      OPTIONS_INCOME: "Reddito da opzioni",
      RENT: "Affitto",
      HOA_COMMUNITY_FEES: "Spese condominiali",
      SECURITY_DEPOSIT: "Cauzione",
      HOME_INSURANCE: "Assicurazione casa",
      POWER_AND_GAS: "Luce e gas",
      WATER: "Acqua",
      DATA_PLAN: "Piano dati",
      INTERNET: "Internet",
      CLEANING_SERVICE: "Servizio di pulizia",
      HOME_IMPROVEMENT: "Ristrutturazione casa",
      GROCERIES: "Spesa alimentare",
      CONVENIENCE_STORES: "Minimarket",
      DOCTOR: "Medico",
      HEALTH_INSURANCE: "Assicurazione sanitaria",
      PHARMACY: "Farmacia",
      BIKING: "Bicicletta",
      FUEL_AND_GAS: "Carburante",
      VEHICLE_MAINTENANCE: "Manutenzione veicolo",
      VEHICLE_TAXES_AND_TICKETS: "Bollo e multe",
      VEHICLE_INSURANCE: "Assicurazione veicolo",
      METRO: "Metro",
      PARKING: "Parcheggio",
      TAXI: "Taxi",
      TRAINS: "Treni",
      BUS: "Autobus",
      PET_CARE: "Cura animali",
      PET_FOOD: "Cibo per animali",
      PET_INSURANCE: "Assicurazione animali",
      BANKING_FEES: "Spese bancarie",
      DOCUMENTATION: "Documentazione",
      NOTARY: "Notaio",
      ACCOUNTING: "Contabilit\u00E0",
      BUSINESS_MEAL: "Pranzo di lavoro",
      RESTAURANTS: "Ristoranti",
      BAKERY_AND_COFFEE: "Panetteria e caff\u00E8",
      FOOD_DELIVERY: "Consegna a domicilio",
      BAR: "Bar",
      NIGHTCLUB: "Discoteca",
      CONCERTS: "Concerti",
      MOVIES_AND_THEATER: "Cinema e teatro",
      OUTDOOR_ACTIVITIES: "Attivit\u00E0 all'aperto",
      SPORTING_EVENTS: "Eventi sportivi",
      GAMBLING: "Gioco d'azzardo",
      GAMING: "Videogiochi",
      BEAUTY: "Bellezza",
      HAIRCARE: "Cura dei capelli",
      SPORTS_AND_GYM: "Sport e palestra",
      SHOPPING: "Shopping",
      ELECTRONICS: "Elettronica",
      FURNITURE_AND_DIY: "Arredamento e fai da te",
      CLOTHES_AND_FASHION: "Abbigliamento e moda",
      GIFTS: "Regali",
      JEWELRY: "Gioielli",
      DECORATION_AND_TEXTILES: "Decorazione e tessili",
      KITCHENWARE: "Articoli per la cucina",
      SOFTWARE: "Software",
      CONTENT_AND_MEDIA: "Contenuti e media",
      LOYALTY_PROGRAMS: "Programmi fedelt\u00E0",
      CASH_AT_ATM: "Prelievo al bancomat",
      INHERITANCE: "Eredit\u00E0",
      RECEIVED_DOMESTIC: "Bonifico Ricevuto — Nazionale",
      RECEIVED_INTERNATIONAL: "Bonifico Ricevuto — Internazionale",
      SENT_DOMESTIC: "Bonifico Inviato — Nazionale",
      SENT_INTERNATIONAL: "Bonifico Inviato — Internazionale",
      BIZ_SALES_REVENUE: "Ricavi da vendite",
      BIZ_SERVICE_REVENUE: "Ricavi da servizi",
      BIZ_REFERRAL_INCOME: "Referral e affiliazione",
      BIZ_INVENTORY: "Inventario e materiali",
      BIZ_SHIPPING: "Spedizioni e logistica",
      BIZ_SAAS: "SaaS e strumenti",
      BIZ_CLOUD: "Cloud e hosting",
      BIZ_MARKETING: "Marketing e pubblicit\u00E0",
      BIZ_DATA_SERVICES: "Servizi dati e API",
      BIZ_OFFICE: "Ufficio e spazio di lavoro",
      BIZ_DOMAINS: "Domini e licenze",
      BIZ_EQUIPMENT: "Attrezzature aziendali",
      BIZ_OTHER_COSTS: "Altri costi aziendali",
      BIZ_FREELANCERS: "Freelancer e consulenti",
      BIZ_PROFESSIONAL_SERVICES: "Servizi professionali",
      BIZ_TAXES: "Imposte aziendali e IVA",
      BIZ_CAPITAL: "Iniezione di capitale",
      MUSIC: "Strumenti musicali",
      THERAPY_AND_COUNSELING: "Terapia e consulenza",
      MENTORING: "Coaching e mentoring",
      SCHOOL: "Scuola",
      ONLINE_COURSES: "Corsi online",
      TRAVEL_TRANSPORT: "Trasporto di viaggio",
      ACCOMMODATION: "Alloggio",
      CAR_RENTAL: "Noleggio auto",
      TOURS_AND_ACTIVITIES: "Tour e attivit\u00E0",
      TRAVEL_EXPENSES: "Spese di viaggio",
      DONATIONS: "Donazioni",
      BOOKS: "Libri",
    },
    descriptions: {
      SENT_DOMESTIC: "Denaro inviato a qualcuno nel tuo paese — rimborsi ad amici, bonifici tra i tuoi conti, o qualsiasi addebito non legato a un acquisto.",
      SENT_INTERNATIONAL: "Denaro inviato all'estero — bonifici a familiari, ai tuoi conti all'estero, o qualsiasi addebito transfrontaliero non legato a un acquisto.",
      RECEIVED_DOMESTIC: "Denaro ricevuto da qualcuno nel tuo paese — rimborsi da amici, bonifici tra i tuoi conti, o altri accrediti non legati al reddito.",
      RECEIVED_INTERNATIONAL: "Denaro ricevuto dall'estero — regali da familiari, bonifici dai tuoi conti all'estero, o altri accrediti transfrontalieri non legati al reddito.",
      BIZ_SERVICE_REVENUE: "Ricavi da servizi resi dalla tua attività o progetto secondario. Se il lavoro autonomo è la tua attività principale e non un'attività secondaria, usa Reddito da Lavoro Autonomo (in Reddito da Lavoro).",
      BIZ_SALES_REVENUE: "Ricavi dalla vendita di beni della tua attività o progetto secondario.",
      BIZ_OTHER_REVENUE: "Altre fonti di ricavo della tua attività o progetto secondario — licenze, royalty, pagamenti di partner, ecc.",
      ALLOWANCE: "Paghetta, soldi di tasca o supporto familiare continuativo. Utile per studenti e per l'uso di Bliss nelle scuole dove gli utenti registrano denaro ricevuto dalla famiglia.",
      GOVERNMENT_WELFARE: "Trasferimenti pubblici — indennità di disoccupazione, assegni familiari, previdenza sociale o simili. Non sono redditi da lavoro.",
      INHERITANCE: "Denaro o beni ereditati da un familiare deceduto. Classificato in Bonifici perché è un valore una tantum, non un reddito da lavoro o da investimento — tenerlo qui evita di distorcere le tendenze annuali di reddito.",
      FREELANCE_INCOME: "Reddito da lavoro autonomo o consulenza considerato la tua attività principale. Se il lavoro è un'attività secondaria con la propria contabilità, usa Ricavi da Servizi (in Imprese).",
      BONUS: "Bonus annuali, trimestrali o una tantum pagati dal datore di lavoro. Spesso tassati diversamente dallo stipendio regolare — separarli facilita la lettura delle tendenze di reddito.",
      COMMISSION: "Commissioni di vendita o altre retribuzioni a performance legate ai ricavi generati.",
      TAX_REFUND: "Rimborso ricevuto dall'autorità fiscale per un pagamento in eccesso in un periodo precedente.",
    },
    groups: {
      Cash: "Liquidit\u00E0",
      Stocks: "Azioni",
      Funds: "Fondi",
      ETFs: "ETF",
      "Pension Plan": "Piano pensionistico",
      Bonds: "Obbligazioni",
      Crypto: "Crypto",
      "Real Estate": "Immobili",
      Collectible: "Collezione",
      "Depreciating assets": "Beni ammortizzabili",
      Commodities: "Materie prime",
      "Private Equity": "Private Equity",
      "Real Estate Loan": "Mutuo immobiliare",
      "Personal Debt": "Debito personale",
      "Passive Income": "Reddito passivo",
      "Labor Income": "Reddito da lavoro",
      Taxes: "Tasse",
      Housing: "Abitazione",
      Utilities: "Utenze",
      "Home Maintenance": "Manutenzione casa",
      "Eating In": "Mangiare a casa",
      Healthcare: "Sanit\u00E0",
      Transportation: "Trasporti",
      Pets: "Animali domestici",
      Finance: "Finanza",
      Civil: "Civile",
      "Dining Out": "Mangiare fuori",
      Entertainment: "Intrattenimento",
      "Wellness & Beauty": "Benessere e bellezza",
      "Shopping & Gifts": "Shopping e regali",
      Subscriptions: "Abbonamenti",
      Misc: "Varie",
      Inheritance: "Eredit\u00E0",
      Domestic: "Nazionale",
      International: "Internazionale",
      Revenue: "Ricavi",
      "Cost of Goods Sold": "Costo del venduto",
      "Operating Expenses": "Spese operative",
      "People & Services": "Persone e servizi",
      Capital: "Capitale",
      Skills: "Competenze",
      "Mental Health": "Salute mentale",
      Education: "Istruzione",
      Travel: "Viaggi",
      Donations: "Donazioni",
      Other: "Altro",
      Others: "Altri",
      "N/A": "N/D",
    },
    types: {
      Income: "Entrate",
      Essentials: "Essenziali",
      Lifestyle: "Stile di vita",
      Growth: "Crescita",
      Ventures: "Imprese",
      Investments: "Investimenti",
      Asset: "Attivo",
      Debt: "Passivo",
      Transfers: "Trasferimenti",
    },
    processingHints: {
      API_STOCK: "API prezzi azionari",
      API_CRYPTO: "API prezzi crypto",
      API_FUND: "API prezzi fondi",
      AMORTIZING_LOAN: "Monitoraggio prestito",
      SIMPLE_LIABILITY: "Monitoraggio passivit\u00E0",
      CASH: "Monitoraggio liquidit\u00E0",
      MANUAL: "Manuale",
      TAX_DEDUCTIBLE: "Deducibile fiscalmente",
      DEBT: "Monitoraggio debito",
      COPY_TRADING: "Copy Trading eToro",
    },
  },

  // Accounts page
  accountsPage: {
    title: "Conti",
    subtitle: "Gestisci le connessioni bancarie e i conti manuali.",
    connectBank: "Collega conto bancario",
    addManual: "Aggiungi conto manuale",
    selectAccount: "Seleziona un conto",
    selectAccountHint: "Scegli un conto dalla lista per visualizzare i dettagli della connessione, i log di sincronizzazione e le azioni di gestione.",
    deleteTitle: "Elimina conto",
    deleteConfirm: "Sei sicuro di voler eliminare \"{{name}}\"? Questa azione non pu\u00F2 essere annullata.",
    deleteSuccess: "Conto eliminato",
    deleteSuccessDetail: "{{name}} \u00E8 stato rimosso.",
    deleteFailed: "Impossibile eliminare il conto",
    deleteAction: "Elimina conto",
    dangerZone: "Zona pericolosa",
    deleteBlockedTransactions_one: "Questo conto ha {{count}} transazione collegata e non pu\u00F2 essere eliminato finch\u00E9 non viene rimossa o riassegnata a un altro conto.",
    deleteBlockedTransactions_other: "Questo conto ha {{count}} transazioni collegate e non pu\u00F2 essere eliminato finch\u00E9 non vengono rimosse o riassegnate a un altro conto.",
    deleteBlockedTransactions: "Questo conto ha {{count}} transazioni collegate e non pu\u00F2 essere eliminato finch\u00E9 non vengono rimosse o riassegnate a un altro conto.",
    deleteBlockedPlaid: "Questo conto \u00E8 ancora collegato alla tua banca. Disconnetti prima la connessione bancaria, poi elimina il conto.",
    deleteBlockedPlaidHint: "Disconnetti prima questa connessione bancaria (usa \"Sospendi sincronizzazione\" qui sopra) prima di eliminare il conto.",
    deleteUnknownError: "Impossibile eliminare questo conto. Riprova.",
    searchAccounts: "Cerca conti...",
    noAccountsMatch: "Nessun conto corrisponde alla ricerca.",
    noAccountsYet: "Nessun conto ancora.",
    synced: "Sincronizzato",
    actionRequired: "Azione richiesta",
    disconnected: "Disconnesso",
    manual: "Manuale",
  },

  // Account detail panel
  accountDetail: {
    edit: "Modifica",
    plaidConnected: "Plaid collegato",
    placeholderNumberHint: "Questo conto ha ancora un numero provvisorio dalla configurazione.",
    addAccountNumber: "Aggiungi il numero di conto reale",
    connectionHealth: "Stato connessione",
    consentExpired: "Consenso scaduto",
    consentExpiringSoon: "Consenso in scadenza",
    consentExpiredOn: "Il consenso bancario \u00E8 scaduto il {{date}}. Riconnetti per riprendere la sincronizzazione.",
    consentExpiresOn: "Il consenso bancario scade il {{date}} ({{days}} giorno rimanente). Riconnetti prima della scadenza.",
    consentExpiresOnPlural: "Il consenso bancario scade il {{date}} ({{days}} giorni rimanenti). Riconnetti prima della scadenza.",
    reconnect: "Riconnetti",
    disconnectedMessage: "Questa connessione bancaria \u00E8 stata disconnessa. Ricollega per riprendere la sincronizzazione delle transazioni.",
    reconnectBank: "Ricollega banca",
    actions: "Azioni",
    resyncNow: "Risincronizza ora",
    rotateToken: "Ruota token",
    relinkPlaid: "Ricollega Plaid",
    pauseSync: "Pausa sincronizzazione",
    security: "Sicurezza",
    securityEncryption: "Tutti i dati del conto sono crittografati a riposo con AES-256-GCM.",
    securityTokens: "I token di accesso Plaid vengono ruotati periodicamente e archiviati crittografati.",
    pauseSyncDescription: "Questo metter\u00E0 in pausa la sincronizzazione per questo conto. Le transazioni esistenti e la cronologia delle connessioni non saranno modificate. Puoi riconnetterti in qualsiasi momento.",
    disconnect: "Disconnetti",
    disconnecting: "Disconnessione...",
    syncTriggered: "Sincronizzazione avviata",
    syncTriggeredDetail: "Una nuova sincronizzazione \u00E8 stata avviata per questo conto.",
    syncFailed: "Impossibile avviare la sincronizzazione",
    tokenRotated: "Token ruotato",
    tokenRotatedDetail: "Il token di accesso \u00E8 stato ruotato con successo.",
    tokenRotateFailed: "Impossibile ruotare il token",
    disconnected: "Disconnesso",
    disconnectedDetail: "La connessione bancaria \u00E8 stata rimossa.",
    disconnectFailed: "Impossibile disconnettere",
    securityDesc: "Tutti i dati del conto sono crittografati a riposo con AES-256-GCM.",
    securityPlaid: "I token di accesso Plaid vengono ruotati periodicamente e archiviati crittografati.",
    syncTriggeredDesc: "Una nuova sincronizzazione \u00E8 stata avviata per questo conto.",
    tokenRotatedDesc: "Il token di accesso \u00E8 stato ruotato con successo.",
    disconnectedDesc: "La connessione bancaria \u00E8 stata rimossa.",
    reconnectDesc: "Questa connessione bancaria \u00E8 stata disconnessa. Ricollega per riprendere la sincronizzazione delle transazioni.",
    pauseSyncTitle: "Pausa sincronizzazione",
    pauseSyncDesc: "Questo metter\u00E0 in pausa la sincronizzazione per questo conto. Le transazioni esistenti e la cronologia delle connessioni non saranno modificate. Puoi riconnetterti in qualsiasi momento.",
    consentExpiredDesc: "Il consenso bancario \u00E8 scaduto il {{date}}. Riconnetti per riprendere la sincronizzazione.",
    consentExpiringSoonDesc: "Il consenso bancario scade il {{date}} ({{days}} giorni rimanenti). Riconnetti prima della scadenza.",
  },

  // Add/edit account modal
  accountModal: {
    editTitle: "Modifica conto",
    addTitle: "Aggiungi conto manuale",
    editDescription: "Aggiorna i dettagli del tuo conto.",
    addDescription: "Aggiungi un nuovo conto gestito manualmente.",
  },

  // Connection health
  connectionHealth: {
    status: "Stato",
    lastSynced: "Ultima sincronizzazione",
    nextSync: "Prossima sincronizzazione",
    approxInterval: "~6 ore",
    historyRange: "Intervallo storico",
    notYetSynced: "Non ancora sincronizzato",
    historyStatus: "Stato storico",
    complete: "Completo",
    syncingHistory: "Sincronizzazione cronologia completa...",
    institutionId: "ID istituto",
    connection: "Connessione",
    manualEntry: "Inserimento manuale",
    fetchOlder: "Recupera transazioni precedenti",
    selectStartDate: "Seleziona una data di inizio (fino a 2 anni fa)",
    fetchFrom: "Recupera da",
    selectDate: "Seleziona una data",
    title: "Stato connessione",
    backfillStarted: "Recupero avviato",
    backfillDetail: "Recupero transazioni dal {{date}}. Potrebbe richiedere un momento.",
    backfillFailed: "Impossibile avviare il recupero",
    nextSyncValue: "~6 ore",
    fetching: "Recupero...",
    never: "Mai",
    justNow: "Adesso",
    minutesAgo: "{{count}}m fa",
    hoursAgo: "{{count}}h fa",
    daysAgo: "{{count}}g fa",
    today: "Oggi",
    fetchOlderTransactions: "Recupera transazioni precedenti",
  },

  // Transaction review page
  review: {
    confident: "Sicuro",
    newMerchant: "Nuovo esercente",
    actionNeeded: "Azione richiesta",
    uncertain: "Incerto",
    duplicate: "Duplicato",
    possibleDup: "Possibile dup.",
    approveAll: "Approva tutto",
    date: "Data",
    merchant: "Esercente",
    account: "Conto",
    amount: "Importo",
    confidence: "Conf.",
    status: "Stato",
    actions: "Azioni",
    uncategorized: "Non categorizzato",
    required: "Obbligatorio",
    selectAccount: "Seleziona conto",
    noAccount: "Nessun conto",
    investmentEnrichmentRequired: "L'arricchimento dell'investimento \u00E8 richiesto per questa categoria. Compila ticker, quantit\u00E0 e prezzo.",
    investmentEnrichmentRequiredTickerOptional: "L'arricchimento dell'investimento \u00E8 richiesto per questa categoria. Compila quantit\u00E0 e prezzo; il ticker \u00E8 facoltativo per i fondi non quotati.",
    currencyMismatch: "Questo asset \u00E8 quotato in {{assetCurrency}} ma la transazione \u00E8 in {{txCurrency}}. I valori del portafoglio potrebbero richiedere la conversione valutaria.",
    detailsNotes: "Dettagli / Note",
    optionalNotes: "Sostituzione note opzionale",
    tags: "Tag",
    skip: "Salta",
    merchantHistory: "Storico esercente",
    noMerchantHistory: "Nessuna transazione precedente trovata per questo esercente.",
    blissAnalysis: "Analisi Bliss",
    aiConfidence: "Confidenza AI",
    source: "Fonte",
    plaidCategory: "Categoria Plaid",
    classificationReasoning: "Motivazione della classificazione",
    whyChose: "Perch\u00E9 ho scelto questa",
    sourceLabels: {
      USER_OVERRIDE: "Impostato da te",
      EXACT_MATCH: "Corrispondenza dalla cronologia",
      VECTOR_MATCH: "Simile alla tua cronologia",
      VECTOR_MATCH_GLOBAL: "Corrispondenza dalla comunità",
      LLM: "Classificazione IA",
      PLAID_HINT: "Suggerito dalla banca",
      default: "Analisi AI",
    },
    enrichmentRequired: "Arricchimento richiesto",
    enrichmentDescription: "Questa transazione sembra legata a un investimento. Fornisci i dettagli qui sotto per tracciarla correttamente nel tuo portafoglio.",
    tickerSymbol: "Simbolo ticker",
    tickerOptional: "facoltativo",
    tickerPlaceholder: "es. VWCE, AAPL",
    pricePerShare: "Prezzo per azione",
    pricePlaceholder: "es. 43,67",
    quantity: "Quantit\u00E0",
    quantityAuto: "(auto)",
    quantityCalculated: "Calcolato automaticamente",
    quantityPlaceholder: "es. 1,23",
    notesPlaceholder: "Note opzionali (sovrascrive la descrizione predefinita della transazione)",
    selectCategory: "Seleziona una categoria",
    selectDate: "Seleziona una data",
    descriptionRequired: "La descrizione \u00E8 obbligatoria",
    selectCurrency: "Seleziona una valuta",
    selectAccountValidation: "Seleziona un conto",
    // Page-level strings
    pageTitle: "Revisione transazioni",
    pageSubtitle: "Rivedi e approva le transazioni in sospeso da tutte le fonti.",
    requeueSkipped: "Rimetti in coda le saltate",
    bulkPromote: "Promozione massiva",
    reviewedProgress: "{{done}} di {{total}} revisionate",
    allPending: "Tutte in sospeso",
    fromPlaid: "Da Plaid",
    fromImports: "Da importazioni",
    allCaughtUp: "Tutto aggiornato!",
    noPendingTransactions: "Nessuna transazione in sospeso da revisionare.",
    plaidTransactions: "Transazioni Plaid",
    importTransactions: "Transazioni importate",
    pending: "in sospeso",
    cancelImport: "Annulla importazione",
    noPlaidToReview: "Nessuna transazione Plaid da revisionare",
    allPlaidProcessed: "Tutte le transazioni Plaid sono state elaborate.",
    noPendingImports: "Nessuna importazione in sospeso",
    allImportsCommitted: "Tutte le importazioni sono state confermate.",
    committingTransactions: "Conferma transazioni...",
    complete: "completato",
    noRowsInImport: "Nessuna riga in questa importazione.",
    committing: "Conferma...",
    commitAll: "Conferma tutto",
    // Deep dive drawer
    selectCategoryPlaceholder: "Seleziona categoria",
    saveChanges: "Salva modifiche",
    saveAndPromote: "Salva e promuovi",
    resetToPending: "Riporta in attesa",
    resetToPendingDesc: "Riporta questa riga in attesa così non viene confermata automaticamente. Utile per annullare una classificazione auto-promossa che vuoi riesaminare.",
    // Bulk promote dialog
    bulkPromoteTitle: "Promozione massiva transazioni",
    bulkPromoteDescription: "Promuovi automaticamente tutte le transazioni Plaid classificate che superano la soglia di confidenza.",
    minConfidenceThreshold: "Soglia minima di confidenza",
    threshold90: "90% (Pi\u00F9 conservativo)",
    threshold80: "80% (Consigliato)",
    threshold70: "70%",
    threshold50: "50% (Meno conservativo)",
    thresholdHint: "Solo le transazioni con confidenza AI pari o superiore a questa soglia verranno promosse.",
    promoteAll: "Promuovi tutte",
    promoting: "Promozione...",
    // Promote-by-description dialog
    promoteMatchingTitle: "Promuovere le transazioni corrispondenti?",
    promoteMatchingDescription: "Trovate <strong>{{count}} transazion{{plural}} in sospeso</strong> denominate \"{{description}}\".",
    justThisOne: "Solo questa",
    promoteAllCount: "Promuovi tutte le {{count}}",
    // Drawer promote-all dialog
    confirmMatchingTitle: "Confermare anche le transazioni corrispondenti?",
    confirmMatchingDescription: "Ci {{verb}} <strong>{{count}} altr{{plural}} transazion{{plural}} in sospeso</strong> denominate \"{{description}}\". Confermarle tutte come <strong>{{category}}</strong>?",
    confirmAllCount: "Conferma tutte le {{count}}",
    confirming: "Conferma...",
    // Pagination
    pageOf: "Pagina {{current}} di {{total}}",
    // Source labels (additional)
    unknown: "Sconosciuto",
    // Errore di classificazione e nuovo tentativo
    classificationFailed: "Classificazione non riuscita",
    retryClassification: "Riprova classificazione",
    failedTransactionsBanner: "{{count}} transazione/i con classificazione non riuscita",
    retrySuccess: "Nuovo tentativo avviato",
    retryError: "Impossibile avviare il nuovo tentativo",
    errorTimedOut: "La classificazione AI è scaduta — riprova o classifica manualmente",
    errorRateLimited: "Limite di richieste del provider AI raggiunto — riprova tra poco",
    errorGeneric: "La classificazione AI non è riuscita — riprova o classifica manualmente",
    // Smart Import hold-back reasons (#142)
    holdBack: {
      missingFields: "Manca: {{fields}}",
      fieldTicker: "ticker",
      fieldQuantity: "quantità",
      fieldPrice: "prezzo",
      missingAccount: "Conto mancante",
      duplicate: "Duplicato",
      updateFailed: "Aggiornamento non riuscito",
      commitError: "Errore di conferma",
      filterLabel: "Solo trattenute",
    },
    commitToast: {
      committedTitle: "Importazione confermata",
      partialTitle: "Conferma parziale completata",
      created: "{{count}} create",
      updated: "{{count}} aggiornate",
      noneCommitted: "Nessuna riga confermata",
      heldBack: "{{count}} trattenute: {{reasons}}",
      missingTicker_one: "{{count}} senza ticker",
      missingTicker_other: "{{count}} senza ticker",
      missingQuantity_one: "{{count}} senza quantità",
      missingQuantity_other: "{{count}} senza quantità",
      missingPrice_one: "{{count}} senza prezzo",
      missingPrice_other: "{{count}} senza prezzo",
      missingAccount_one: "{{count}} senza conto",
      missingAccount_other: "{{count}} senza conto",
      duplicate_one: "{{count}} duplicata",
      duplicate_other: "{{count}} duplicate",
      updateFailed_one: "{{count}} aggiornamento non riuscito",
      updateFailed_other: "{{count}} aggiornamenti non riusciti",
      commitError_one: "{{count}} errore di conferma",
      commitError_other: "{{count}} errori di conferma",
      stillToReview: "{{count}} ancora da rivedere",
      done: "Fatto.",
    },
  },

  // Currency rates page
  currencyRates: {
    title: "Tassi di cambio",
    subtitle: "Gestisci i tassi di cambio per i calcoli finanziari",
    refreshRates: "Aggiorna tassi",
    addRate: "Aggiungi tasso",
    searchPlaceholder: "Cerca valute o fornitori...",
    from: "Da",
    to: "A",
    rate: "Tasso",
    year: "Anno",
    month: "Mese",
    day: "Giorno",
    provider: "Fornitore",
    lastUpdated: "Ultimo aggiornamento",
    noRatesFound: "Nessun tasso trovato",
    addTitle: "Aggiungi tasso di cambio",
    providerOptional: "Fornitore (facoltativo)",
    adding: "Aggiunta...",
  },

  // User management page
  userManagement: {
    title: "Gestione utenti",
    subtitle: "Gestisci gli utenti e il loro accesso al tuo tenant",
    createUser: "Crea utente",
    createTitle: "Crea un nuovo utente",
    createDescription: "Crea un nuovo account utente con credenziali di accesso.",
    editTitle: "Modifica utente",
    editDescription: "Aggiorna le informazioni dell'utente e i permessi di accesso",
    name: "Nome",
    namePlaceholder: "Inserisci il nome",
    emailAddress: "Indirizzo email",
    emailPlaceholder: "Inserisci l'indirizzo email",
    password: "Password",
    passwordPlaceholder: "Imposta una password (min 6 caratteri)",
    role: "Ruolo",
    selectRole: "Seleziona ruolo",
    roleAdmin: "Amministratore",
    roleMember: "Membro",
    roleViewer: "Visualizzatore (sola lettura)",
    preferredLanguage: "Lingua preferita",
    selectLanguage: "Seleziona lingua",
    birthDate: "Data di nascita",
    cancel: "Annulla",
    updateUser: "Aggiorna utente",
    tenantUsers: "Utenti del tenant",
    tenantUsersDescription: "Gestisci gli utenti con accesso ai tuoi dati finanziari",
    searchUsers: "Cerca utenti...",
    statusFilter: "Stato",
    allStatuses: "Tutti gli stati",
    statusActive: "Attivo",
    statusPending: "In attesa",
    statusInactive: "Inattivo",
    showing: "Visualizzazione",
    of: "di",
    users: "utenti",
    user: "Utente",
    lastLogin: "Ultimo accesso",
    never: "Mai",
    editUser: "Modifica utente",
    resendInvitation: "Reinvia invito",
    removeUser: "Rimuovi utente",
    noUsersFound: "Nessun utente trovato con i filtri applicati",
    userCreated: "Utente creato",
    userCreatedDetail: "{{name}} \u00E8 stato creato con successo",
    userCreateFailed: "Qualcosa \u00E8 andato storto durante la creazione dell'utente",
    userUpdated: "Utente aggiornato",
    userUpdatedDetail: "{{name}} \u00E8 stato aggiornato con successo",
    userUpdateFailed: "Qualcosa \u00E8 andato storto durante l'aggiornamento dell'utente",
    userRemoved: "Utente rimosso",
    userRemovedDetail: "L'utente \u00E8 stato rimosso da questo tenant",
    userRemoveFailed: "Qualcosa \u00E8 andato storto durante la rimozione dell'utente",
    invitationSent: "Invito inviato",
    invitationSentDetail: "Un nuovo invito \u00E8 stato inviato a {{email}}",
    invitationFailed: "Qualcosa \u00E8 andato storto durante il reinvio dell'invito",
    relationSelf: "Se stesso",
    relationPartner: "Partner",
    relationChild: "Figlio/a",
    relationRelative: "Altro parente",
    relationFriend: "Amico/a",
    relationColleague: "Collega",
    relationOther: "Altro",
  },

  // Equity analysis page
  equityAnalysis: {
    diversified: "Diversificato",
    etfBadge: "ETF",
    basedOn: "sul {{pct}}% del valore",
    unmapped: "{{pct}}% non identificato",
    copyBadge: "Copia",
    viaCopy: "tramite @{{username}}",
    viaCopyIncluded: "di cui {{value}} tramite @{{username}}",
    copyCash: "Liquidità",
    copyUnmapped: "Non identificato",
    copySplit: "{{value}} suddiviso in {{count}} posizioni",
    title: "Analisi azionaria",
    subtitle: "Analizza i tuoi investimenti per settore, industria, paese e classe di attivo",
    totalEquityValue: "Valore azionario totale",
    holdings: "Partecipazioni",
    avgPE: "P/E medio",
    avgDividendYield: "Rendimento dividendi medio",
    groupBy: "Raggruppa per:",
    sector: "Settore",
    industry: "Industria",
    country: "Paese",
    allocationBy: "Allocazione per {{grouping}}",
    noStockHoldings: "Nessuna partecipazione in azioni o ETF trovata",
    top10: "Top 10 partecipazioni per peso",
    allHoldings: "Tutte le partecipazioni in azioni ed ETF",
    noHoldingsHint: "Nessuna partecipazione trovata. Aggiungi azioni o ETF al tuo portafoglio per vedere l'analisi azionaria.",
    symbol: "Simbolo",
    name: "Nome",
    pe: "P/E",
    divYield: "Rend. div.",
    eps: "EPS",
    weekRange: "Range 52 sett.",
    weight: "Peso",
    value: "Valore",
    loadFailed: "Impossibile caricare i dati dell'analisi azionaria.",
    assetClass: "Classe di attivo",
    lookThrough: "Scomponi gli ETF",
    lookThroughHint: "Ripartisce ogni ETF tra i settori e i paesi che detiene",
    lookThroughWithCopies: "Scomponi ETF e copie",
    lookThroughHintWithCopies: "Ripartisce ogni ETF tra i settori e i paesi che detiene e mostra ogni copia eToro come le posizioni in cui investe",
    pendingSecurityData: "In attesa dei dati del titolo per {{symbols}}. Questi fondi compariranno qui appena saranno disponibili.",
    lookThroughOther: "Altro",
    fixedIncomeBucket: "Reddito fisso",
    editAssetClass: "Modifica la classe di attivo di {{symbol}}",
    automatic: "Automatica ({{assetClass}})",
    overrideSaved: "Classe di attivo aggiornata",
    overrideFailed: "Impossibile aggiornare la classe di attivo",
    overrideHint: "Impostata manualmente",
    etfBreakdown: "Settori principali",
    save: "Salva",
    cancel: "Annulla",
    assetClasses: {
      STOCK: "Azione",
      INDEX_ETF: "ETF indicizzato",
      SECTOR_ETF: "ETF settoriale",
      BOND_ETF: "ETF obbligazionario",
      REIT: "REIT",
      FUND: "Fondo",
      GOV_BOND: "Titolo di Stato",
      CORP_BOND: "Obbligazione societaria",
      REAL_ESTATE: "Immobile",
      CRYPTO: "Cripto",
      CASH: "Liquidità",
      OTHER: "Altro",
      COPY_TRADE: "Copy trading",
    },
  },

  // Not Found page
  notFoundPage: {
    code: "404",
    message: "Oops! Pagina non trovata.",
    returnHome: "Torna alla home",
  },

  // Plaid connect
  plaidConnect: {
    success: "Successo",
    bankReauthenticated: "Connessione bancaria ri-autenticata con successo.",
    reauthFailed: "Ri-autenticazione riuscita ma aggiornamento dello stato fallito.",
    exchangeFailed: "Scambio fallito",
    connectFailed: "Impossibile collegare il conto bancario.",
    reconnect: "Riconnetti",
    connectBank: "Collega banca",
  },

  // Account selection modal
  accountSelection: {
    loadFailed: "Impossibile caricare i conti dalla banca.",
    allAccountTypes: "Tutti i tipi di conto",
    createNew: "Crea nuovo",
    createNewAccount: "Crea nuovo conto",
    linkToExisting: "Collega a esistente",
    selectOrCreate: "Seleziona o crea",
    accountNames: "Nomi dei conti",
    accountMappings: "Mappatura conti",
    unsupportedCurrencies: "Valute non supportate",
    unsupportedCountry: "Paese non supportato",
    seedInterview: "Intervista iniziale",
    allCategories: "Tutte le categorie",
    fetchFailed: "Impossibile recuperare i conti Plaid",
    setupTitle: "Configura conti",
    syncingTitle: "Sincronizzazione in corso...",
    quickClassify: "Classificazione rapida",
    syncComplete: "Sincronizzazione completata",
    setupDescription: "Scegli i conti da sincronizzare, collegali a quelli esistenti e imposta i nomi.",
    syncingDescription: "Le tue transazioni sono in fase di sincronizzazione e classificazione dall'AI.",
    seedDescription: "Abbiamo trovato le tue transazioni pi\u00F9 ricorrenti. Conferma o modifica le categorie per rendere l'AI pi\u00F9 intelligente alla prossima sincronizzazione.",
    doneDescription: "Tutte le transazioni sono state sincronizzate e classificate.",
    newCurrenciesDetected: "Nuove valute rilevate",
    currenciesUse: "Questi conti utilizzano",
    currenciesNotConfigured: "che {{plurality}} non ancora nel tuo spazio di lavoro. Verranno aggiunte automaticamente alla sincronizzazione.",
    newCountryDetected: "Nuovo paese rilevato",
    bankOperatesIn: "Questa banca opera in",
    countryNotConfigured: "che non \u00E8 ancora nel tuo spazio di lavoro. Verr\u00E0 aggiunto automaticamente alla sincronizzazione.",
    notConfigured: "non configurato",
    accountNamePlaceholder: "Nome conto",
    existingAccountKept: "Il nome del conto esistente verr\u00E0 mantenuto",
    noAccountsFound: "Nessun conto trovato.",
    syncHistoryNote: "Bliss sincronizzer\u00E0 fino a 2 anni di cronologia. Le transazioni recenti appaiono in pochi secondi; la cronologia completa arriva entro 24 ore.",
    syncAccounts: "Sincronizza {{count}} conti",
    accountsLinked: "Conti collegati",
    syncingTransactions: "Sincronizzazione transazioni",
    aiClassifying: "Classificazione AI",
    importingTransactions: "Importazione delle tue transazioni recenti",
    importingFrom: "da",
    fullHistoryNote: "La cronologia completa di 2 anni continuer\u00E0 a sincronizzarsi in background.",
    promoted: "Promossa",
    pendingReview: "In attesa di revisione",
    processing: "Elaborazione",
    doNotClose: "Non chiudere questa finestra durante la sincronizzazione.",
    skipForNow: "Salta per ora",
    confirmContinue: "Conferma e continua",
    seedSaveFailed: "Impossibile salvare le selezioni delle categorie.",
    historyRange: "Intervallo storico",
    readyForReview: "Pronto per la revisione",
    skippedDuplicates: "Saltati (duplicati)",
    fullHistorySyncing: "Cronologia completa in sincronizzazione in background",
    currentlySyncedFrom: "Attualmente sincronizzato da",
    fullHistoryDetail: "Bliss sincronizzer\u00E0 automaticamente fino a 2 anni di cronologia delle transazioni nelle prossime 24 ore. Le nuove transazioni appariranno nella coda di revisione man mano che arrivano \u2014 nessuna azione necessaria.",
    reviewTransactions: "Revisiona transazioni",
    linkFailed: "Impossibile collegare i conti.",
  },

  // Change password dialog
  changePassword: {
    title: "Cambia password",
    description: "Inserisci la password attuale e scegline una nuova.",
    currentPassword: "Password attuale",
    currentPasswordRequired: "La password attuale \u00E8 obbligatoria",
    newPassword: "Nuova password",
    newPasswordMin: "La password deve essere di almeno 8 caratteri",
    minHint: "Minimo 8 caratteri",
    confirmPassword: "Conferma nuova password",
    confirmRequired: "Conferma la nuova password",
    mismatch: "Le password non corrispondono",
    updatePassword: "Aggiorna password",
    passwordUpdated: "Password aggiornata",
    passwordUpdatedDetail: "La tua password \u00E8 stata cambiata con successo.",
    changeFailed: "Impossibile cambiare la password",
  },

  // Transaction form
  transactionFormPage: {
    pickDate: "Seleziona una data",
    descriptionPlaceholder: "es. Spesa alimentare, Stipendio, Affitto",
    selectAccount: "Seleziona un conto",
    selectCurrency: "Seleziona una valuta",
    selectCategory: "Seleziona una categoria",
    pricePerShare: "Prezzo per azione",
    pricePlaceholder: "es. 43,67",
    quantity: "Quantit\u00E0",
    quantityAuto: "(auto)",
    quantityCalculated: "Calcolato automaticamente",
    quantityPlaceholder: "es. 1,23",
    detailsNotes: "Dettagli / Note",
    notesPlaceholder: "Note opzionali (sovrascrive la descrizione predefinita della transazione)",
    debtTerms: "Condizioni del debito",
    initialBalance: "Saldo iniziale",
    interestRate: "Tasso di interesse (%)",
    termMonths: "Durata (in mesi)",
    originationDate: "Data di emissione",
    tags: "Tag",
    saving: "Salvataggio...",
    updatedSuccess: "Transazione aggiornata con successo.",
    createdSuccess: "Transazione creata con successo.",
    saveFailed: "Impossibile salvare la transazione. Riprova.",
    currencyMismatch: "Questo asset \u00E8 quotato in {{currency}}. Seleziona un conto in {{currency}}.",
    currencyMismatchAlt: "Seleziona un conto in {{currency}} o scegli un asset quotato in {{txCurrency}}.",
    tickerRequired: "Il ticker è obbligatorio per questa categoria.",
    priceRequired: "Il prezzo è obbligatorio per questa categoria.",
    quantityRequired: "La quantità è obbligatoria per questa categoria.",
    dateLabel: "Data",
    descriptionLabel: "Descrizione",
    accountLabel: "Conto",
    creditLabel: "Credito",
    debitLabel: "Debito",
    categoryLabel: "Categoria",
    investmentDetails: "Dettagli investimento",
    investmentDetailsHint: "(seleziona una categoria di investimento per abilitare)",
    tickerLabel: "Ticker",
    tickerPlaceholder: "es. AAPL, VWCE",
    etoroUsernameLabel: "Username eToro",
    etoroUsernamePlaceholder: "Investitore copiato, es. topinvestor",
    copyTradeAmountHint: "Inserisci l'importo versato nella copia (o prelevato). Non ci sono prezzo né quantità: l'importo è il tuo costo ed eToro fornisce il valore.",
    loadingFormData: "Caricamento dati del modulo...",
    closePosition: "Chiudi posizione completa",
    closePositionHint: "Imposta la quantità alla tua posizione esatta di {{quantity}} unità",
    closePositionActive: "Chiusura posizione attiva",
    lotMismatchWarning: "Discrepanza nella quantità della posizione",
    lotMismatchDetail: "Questa posizione mostra una quantità negativa — potrebbe mancare una transazione di acquisto o un trasferimento tra conti non registrato.",
  },

  // Debt terms form
  debtTermsForm: {
    initialBalance: "Saldo iniziale",
    initialBalanceError: "Il saldo iniziale deve essere un numero positivo.",
    interestRate: "Tasso di interesse (%)",
    interestRateNegative: "Il tasso di interesse non pu\u00F2 essere negativo.",
    interestRateTooHigh: "Il tasso di interesse sembra troppo alto.",
    termMonths: "Durata (in mesi)",
    termError: "La durata deve essere un numero positivo di mesi.",
    originationDate: "Data di emissione",
    originationRequired: "\u00C8 richiesta una data di emissione.",
    pickDate: "Seleziona una data",
    saveTerms: "Salva condizioni",
    saving: "Salvataggio...",
    success: "Successo!",
    savedDetail: "Le condizioni del debito per {{name}} sono state salvate.",
    saveFailed: "Impossibile salvare le condizioni del debito. Riprova.",
  },

  // Manual price form
  manualPriceForm: {
    date: "Data",
    pickDate: "Seleziona una data",
    price: "Prezzo",
    pricePlaceholder: "es. 150,50",
    currency: "Valuta",
    currencyPlaceholder: "es. USD",
    notes: "Note (Facoltativo)",
    notesPlaceholder: "es. Fonte della valutazione",
    savePrice: "Salva prezzo",
    saving: "Salvataggio...",
    success: "Successo!",
    savedDetail: "Il prezzo per {{name}} \u00E8 stato aggiornato.",
    saveFailed: "Impossibile aggiornare il prezzo. Riprova.",
  },

  manualPriceHistory: {
    title: "Cronologia prezzi — {{symbol}}",
    dialogDescription: "Rivedi, modifica o rimuovi i prezzi che hai inserito manualmente per questa attività.",
    addTitle: "Registra un prezzo — {{symbol}}",
    editTitle: "Modifica prezzo — {{symbol}}",
    countLabel_one: "{{count}} aggiornamento",
    countLabel_other: "{{count}} aggiornamenti",
    countLabel: "{{count}} aggiornamenti",
    effectiveDate: "Data di validità",
    price: "Prezzo",
    currency: "Valuta",
    notes: "Note",
    recordedOn: "Registrato il",
    actions: "Azioni",
    edit: "Modifica",
    delete: "Elimina",
    back: "Torna alla cronologia",
    differentCurrency: "Questa voce è registrata in una valuta diversa da quella dell'attività.",
    emptyTitle: "Nessun prezzo manuale ancora registrato",
    emptyBody: "Registra il primo prezzo per questa attività per iniziare a costruirne la cronologia.",
    recordFirst: "Registra primo prezzo",
    recordPrice: "Registra prezzo",
    loadError: "Impossibile caricare la cronologia dei prezzi.",
    retry: "Riprova",
    deleteConfirmTitle: "Eliminare questa voce di prezzo?",
    deleteConfirmBody: "Questa operazione rimuove definitivamente il prezzo registrato e riavvia la valutazione del portafoglio. Non può essere annullata.",
    deleted: "Voce di prezzo eliminata",
    deleteFailed: "Impossibile eliminare la voce di prezzo. Riprova.",
    viewHistory: "Visualizza cronologia",
    lastUpdated: "Ultimo aggiornamento",
    allManualAssetsTitle: "Tutte le attività a prezzo manuale",
    allManualAssetsDesc: "Ogni attività che valuti manualmente. Apri la cronologia per rivedere, modificare o rimuovere le voci passate.",
    noManualAssets: "Nessuna attività a prezzo manuale ancora.",
    pagination: "Visualizzazione {{from}}–{{to}} di {{total}}",
    prev: "Precedente",
    next: "Successivo",
  },

  // Category combobox
  categoryCombobox: {
    search: "Cerca categorie...",
    noResults: "Nessuna categoria trovata.",
  },

  // Category form
  categoryFormPage: {
    nameMin: "Il nome deve essere di almeno 2 caratteri",
    typeRequired: "Il tipo \u00E8 obbligatorio",
    groupRequired: "Il gruppo \u00E8 obbligatorio",
    iconLabel: "Icona",
    iconHint: "Incolla un'emoji qualsiasi da usare come icona della categoria.",
    recurringLabel: "Addebito ricorrente",
    recurringHint: "Mostra le transazioni di questa categoria nella vista Abbonamenti. Basta un solo addebito per includerla.",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Spiega brevemente quando usare questa categoria…",
    descriptionHint: "Mostrata come tooltip nel selettore di categorie. Aiuta te (o altri utenti del tuo account) a scegliere la categoria giusta.",
    namePlaceholder: "es. Spesa alimentare, Stipendio, Affitto",
    selectType: "Seleziona tipo",
    selectGroup: "Seleziona gruppo",
    selectTypeFirst: "Seleziona prima un tipo",
    createNewGroup: "+ Crea nuovo gruppo\u2026",
    enterNewGroup: "Inserisci nome del nuovo gruppo",
    iconOptional: "(facoltativo)",
  },

  // Categories page
  categoriesPage: {
    defaultBadge: "Predefinita",
    systemHint: "Categoria di sistema \u2014 usata per la classificazione AI su tutti i tenant. Non pu\u00F2 essere eliminata.",
    transaction: "transazione",
    transactions: "transazioni",
    categoryOptions: "Opzioni categoria",
    rename: "Rinomina",
    addTo: "Aggiungi a {{type}}",
    reassignAndDelete: "Riassegna ed elimina",
    reassignMessage: "\"{{name}}\" ha {{count}} transazione/i. Scegli una categoria a cui riassegnarle prima dell'eliminazione.",
    selectTargetCategory: "Seleziona categoria di destinazione",
    deleteAndReassign: "Elimina e riassegna",
    deletedAndReassigned: "{{name}} eliminata e {{count}} transazione/i riassegnate",
  },

  // Expense split card (dashboard)
  expenseSplit: {
    title: "Ripartizione spese",
    thisYear: "Quest'anno",
    thisMonth: "Questo mese",
    lastMonth: "Mese scorso",
    last3Months: "Ultimi 3 mesi",
    noData: "Nessun dato di spesa per questo periodo.",
    viewExpenses: "Visualizza spese",
    ofSpending: "della spesa",
    basis: "Debiti − crediti",
    netCredits: "Crediti netti",
    noNetSpend: "Nessuna spesa netta in questo periodo",
  },

  // Smart Import page
  smartImport: {
    title: "Importazione intelligente",
    subtitle: "Carica un file CSV o Excel, lascia che l'AI classifichi le transazioni, poi rivedi e conferma.",
    cancelImport: "Annulla importazione",
    steps: {
      upload: "Caricamento",
      processing: "Elaborazione",
      review: "Revisione",
      done: "Completato",
    },
    status: {
      confirmed: "Confermato",
      pending: "In sospeso",
      duplicate: "Duplicato",
      possibleDup: "Possibile dup.",
      skipped: "Saltato",
      error: "Errore",
    },
    source: {
      manual: "Manuale",
      exact: "Esatto",
      vector: "Vettore",
      ai: "AI",
    },
    selectFile: "Seleziona file",
    selectFileDesc: "Scegli un estratto conto o file di esportazione (CSV o Excel) da importare.",
    dropzone: "Clicca per selezionare o trascina un file CSV o Excel",
    detectingFormat: "Rilevamento formato file...",
    formatDetected: "Formato rilevato: {{name}}",
    formatDetectedDesc: "Questo file corrisponde all'adapter {{name}}. La mappatura delle colonne verr\u00E0 applicata automaticamente.",
    unknownFormat: "Formato sconosciuto",
    unknownFormatDesc: "Nessun adapter corrisponde a questo file. Intestazioni rilevate:",
    unknownFormatHeaderHint: "Bliss legge le intestazioni delle colonne dalla prima riga del file (o del foglio, per Excel). Se il file ha righe sopra le intestazioni — nome del conto, periodo, saldo — eliminale e caricalo di nuovo.",
    createAdapterForFormat: "Crea adapter per questo formato",
    destinationAccount: "Conto di destinazione",
    destinationAccountDesc: "Tutte le transazioni verranno importate in questo conto.",
    destinationAccountNative: "Facoltativo \u2014 l'adapter nativo risolve il conto per riga dal tuo CSV.",
    selectAccount: "Seleziona un conto...",
    optionalFromCsv: "Facoltativo \u2014 risolto dal CSV...",
    nativeAccountHint: "La colonna conto di ogni riga sovrascrive questa selezione. Seleziona un fallback qui solo se alcune righe non hanno un conto specificato.",
    uploading: "Caricamento...",
    uploadAndProcess: "Carica ed elabora",
    importAdapters: "Adapter di importazione",
    hide: "Nascondi",
    manage: "Gestisci",
    noAdapters: "Nessun adapter ancora. Creane uno per iniziare a importare.",
    newAdapter: "Nuovo adapter",
    system: "Sistema",
    template: "Modello",
    editAdapter: "Modifica adapter",
    createAdapter: "Crea adapter",
    adapterFormDesc: "Definisci come le colonne CSV/Excel della tua banca si mappano ai campi transazione di Bliss.",
    form: {
      name: "Nome",
      nameRequired: "Il nome dell'adattatore è obbligatorio",
      namePlaceholder: "CSV Conto Corrente",
      matchHeaders: "Intestazioni di corrispondenza",
      matchHeadersPlaceholder: "Data, Descrizione, Importo",
      matchHeadersHint: "Intestazioni di colonna che identificano in modo univoco il formato di esportazione della tua banca.",
      matchHeadersChipsHint: "Seleziona le intestazioni del file che identificano questo formato. Aggiungine una personalizzata se necessario.",
      addCustomHeader: "Aggiungi intestazione personalizzata",
      dateColumn: "Colonna data",
      dateColumnPlaceholder: "Data",
      descriptionColumn: "Colonna descrizione",
      descriptionColumnPlaceholder: "Descrizione",
      amountStrategy: "Struttura importo",
      singleSigned: "Una colonna, con segno (la maggior parte delle banche)",
      singleSignedDesc: "Es. -45,20 = spesa, 25,00 = entrata",
      singleSignedInverted: "Una colonna, segni invertiti (es. Amex)",
      singleSignedInvertedDesc: "Es. 45,20 = spesa, -25,00 = rimborso",
      debitCredit: "Colonne debito e credito separate",
      debitCreditDesc: "Due colonne separate per addebiti e accrediti",
      amountWithType: "Importo + colonna tipo",
      amountWithTypeDesc: "Una colonna importo e una che indica la direzione",
      typeColumn: "Colonna tipo",
      typeColumnPlaceholder: "Tipo",
      categoryColumn: "Colonna categoria (opzionale)",
      categoryColumnPlaceholder: "Nessuna — senza suggerimento categoria",
      categoryColumnHint: "Se il tuo file ha una colonna categoria, mapparla migliora la precisione dell'IA",
      debitColumn: "Colonna debito",
      debitColumnPlaceholder: "Debito",
      creditColumn: "Colonna credito",
      creditColumnPlaceholder: "Credito",
      amountColumn: "Colonna importo",
      amountColumnPlaceholder: "Importo",
      customColumn: "Colonna personalizzata…",
      dateFormat: "Formato data",
      dateFormatAuto: "Rilevamento automatico (consigliato)",
      dateFormatCustom: "Formato personalizzato…",
      dateFormatGroupDate: "Solo data",
      dateFormatGroupDateTime: "Data + Ora",
      dateFormatAmbiguousWarning: "Formato data ambiguo (tutti i valori ≤ 12). Seleziona un formato esplicito per evitare errori MM/GG vs GG/MM.",
      dateFormatHint: "Scegli un formato o seleziona Personalizzato",
      defaultCurrency: "Valuta predefinita",
      currencyHint: "Lascia vuoto se il tuo CSV ha una colonna valuta per riga",
      currencyNone: "Nessuna — usa la colonna valuta per riga",
      skipRows: "Righe da saltare (righe di intestazione da ignorare)",
      previewTitle: "Anteprima riga 1",
      previewHint: "Compila le colonne sopra per vedere come verrà interpretata la riga 1",
      previewNoData: "Carica prima un file per attivare l'anteprima",
      previewDate: "Data",
      previewDescription: "Descrizione",
      previewAmount: "Importo",
      previewCurrency: "Valuta",
      previewBankCategory: "Categoria bancaria",
    },
    unknownFormatSamplePreview: "Righe di esempio dal tuo file:",
    processingTitle: "Elaborazione della tua importazione",
    processingDesc: "L'AI sta classificando le tue transazioni. Potrebbe richiedere un momento...",
    percentComplete: "{{pct}}% completato",
    unknownAccount: "Conto sconosciuto",
    quickClassify: "Classificazione rapida",
    quickClassifyDesc: "Abbiamo trovato le tue transazioni pi\u00F9 ricorrenti. Conferma o modifica le categorie per rendere l'AI pi\u00F9 intelligente per le importazioni future.",
    skipForNow: "Salta per ora",
    confirmAndContinue: "Conferma e continua",
    confirmAll: "Conferma tutto",
    seed: {
      global: "Globale",
      match: "Corrispondenza",
      restore: "Ripristina",
      skipMerchant: "Salta questo esercente",
    },
    review: {
      file: "File",
      account: "Conto",
      total: "Totale",
      nRows: "{{count}} righe",
      earliest: "Pi\u00F9 vecchia",
      autoConfirmed: "{{count}} confermate automaticamente",
      nUpdates: "{{count}} aggiornamenti",
      pendingReview: "{{count}} in attesa di revisione",
      nDuplicates: "{{count}} duplicati",
      nErrors: "{{count}} errori",
      filterByStatus: "Filtra per stato",
      flat: "Piatto",
      grouped: "Raggruppato",
      errorLoadingTitle: "Errore nel caricamento dell'importazione",
      errorLoadingDesc: "Impossibile caricare i dati dell'importazione. Prova ad aggiornare la pagina.",
      noRowsFound: "Nessuna riga trovata",
      tryDifferentFilter: "Prova un filtro diverso.",
      noRowsProduced: "L'importazione non ha prodotto alcuna riga.",
      pageOf: "Pagina {{current}} di {{total}}",
    },
    filter: {
      allRows: "Tutte le righe",
      possibleDuplicate: "Possibile duplicato",
    },
    committingTitle: "Conferma transazioni",
    committingDesc: "Creazione delle transazioni dalle righe confermate...",
    committing: "Conferma...",
    commitImport: "Conferma approvate",
    importError: "Errore di importazione",
    processingError: "Si \u00E8 verificato un errore durante l'elaborazione.",
    processingFailed: "Elaborazione fallita",
    startOver: "Ricomincia",
    importComplete: "Importazione completata!",
    importCompleteDesc: "Le tue transazioni sono state confermate con successo.",
    done: {
      created: "Create",
      updated: "Aggiornate",
      remaining: "Rimanenti",
    },
    importAnotherFile: "Importa un altro file",
    reviewInTransactionReview: "Rivedi nella revisione transazioni",
    commitDialogDesc: "Questo creerà transazioni solo per le righe confermate. Le righe in sospeso rimarranno disponibili per una revisione futura. Questa azione non può essere annullata.",
    goBack: "Torna indietro",
    yesCommit: "S\u00EC, conferma",
    cancelDialogDesc: "Sei sicuro di voler annullare? Tutte le righe in sospeso verranno scartate.",
    cancelling: "Annullamento...",
    yesCancelImport: "S\u00EC, annulla importazione",
    toast: {
      importReady: "Importazione pronta",
      rowsReady: "{{count}} righe pronte per la revisione.",
      seedSaveFailed: "Impossibile salvare le selezioni delle categorie.",
      detectionFailed: "Rilevamento fallito",
      detectionFailedDesc: "Impossibile rilevare il formato del file. Controlla il tuo file CSV o Excel.",
      uploadFailed: "Caricamento fallito",
      uploadFailedDesc: "Impossibile avviare l'importazione. Riprova.",
      otherTransactions: "{{count}} altre transazioni in \"{{category}}\"",
      confirmAllQuestion: "Confermare tutte?",
      confirmedN: "{{count}} transazioni confermate",
      commitStarted: "Conferma avviata",
      commitStartedDesc: "Le tue transazioni sono in fase di conferma...",
      commitFailed: "Conferma fallita",
      commitFailedDesc: "Impossibile avviare il processo di conferma.",
      importCancelled: "Importazione annullata",
      cancelFailed: "Annullamento fallito",
      adapterUpdated: "Adapter aggiornato",
      adapterCreated: "Adapter creato",
      adapterDeleted: "Adapter eliminato",
      formatMatched: "Formato riconosciuto: {{name}}",
      formatMatchedDesc: "Il tuo file \u00E8 ora riconosciuto. Puoi procedere con il caricamento.",
      updateFailed: "Aggiornamento fallito",
      createFailed: "Creazione fallita",
      deleteFailed: "Eliminazione fallita",
    },
  },

  // Insights page
  insights: {
    title: "Analisi",
    subtitle: "Osservazioni basate sull'AI sulle tue finanze",
    v1Subtitle: "Intelligenza finanziaria basata sull'AI: revisioni mensili, tendenze trimestrali, rapporti annuali e analisi del portafoglio",
    lastUpdated: "Ultimo aggiornamento",
    generating: "Generazione...",
    generateNew: "Genera nuove analisi",
    generate: "Genera analisi",
    generateAll: "Genera tutti i livelli",
    refresh: "Aggiorna",
    refreshTier: "Rigenera {{tier}}",
    moreActions: "Altre azioni",
    reload: "Ricarica",
    clearFilters: "Cancella filtri",
    noInsightsYet: "Nessuna analisi ancora",
    noInsightsDesc: "Una volta che avrai dati sulle transazioni, Bliss analizzer\u00E0 le tue finanze e far\u00E0 emergere i modelli che contano.",
    noCategoryInsights: "Nessuna analisi corrisponde ai filtri selezionati. Prova a cancellare i filtri o a cambiare livello.",
    noTierInsightsDesc: "Nessuna analisi disponibile per questo livello ancora. Usa \"Rigenera\" per crearle quando i dati del periodo sono completi.",
    severity: {
      POSITIVE: "Positivo",
      INFO: "Info",
      WARNING: "Avviso",
      CRITICAL: "Critico",
    },
    categories: {
      all: "Tutti",
      spending: "Spese",
      income: "Entrate",
      savings: "Risparmi",
      portfolio: "Portafoglio",
      debt: "Debiti",
      netWorth: "Patrimonio netto",
    },
    tiers: {
      monthly: "Revisione mensile",
      quarterly: "Analisi trimestrale",
      annual: "Rapporto annuale",
      portfolio: "Intelligenza portafoglio",
    },
    lens: {
      passiveIncomeOutlook: "Prospettive del reddito passivo",
    },
    actions: {
      passiveIncomeSetup: "Configura le condizioni di reddito",
      portfolioHoldings: "Portafoglio investimenti",
    },
    period: {
      selectPlaceholder: "Seleziona periodo",
      q: "T",
    },
  },

  // Manual Updates page
  manualUpdates: {
    pageTitle: "Aggiornamenti manuali e condizioni",
    pageSubtitle: "Mantieni aggiornati i tuoi asset manuali e le passivit\u00E0.",
    errorLoading: "Impossibile caricare i dati degli asset. Riprova pi\u00F9 tardi.",
    stalePricesTitle: "Azione richiesta: prezzi obsoleti",
    stalePricesDesc: "Questi asset tracciati manualmente non sono stati aggiornati da oltre 30 giorni.",
    asset: "Asset",
    value: "Valore",
    status: "Stato",
    action: "Azione",
    never: "Mai",
    updatedOn: "Aggiornato il {{date}}",
    dOld: "{{count}}g fa",
    updatePrice: "Aggiorna prezzo",
    allUpToDate: "Tutti gli asset tracciati manualmente sono aggiornati.",
    liabilityTerms: "Condizioni delle passivit\u00E0",
    liabilityTermsDesc: "Gestisci le condizioni dei tuoi prestiti e linee di credito tracciati manualmente.",
    debtName: "Nome debito",
    principalBalance: "Saldo capitale",
    interestRate: "Tasso di interesse",
    duration: "Durata",
    yr: "a",
    mo: "m",
    editTerms: "Modifica condizioni",
    addTerms: "Aggiungi condizioni",
    totalOutstanding: "Totale in sospeso",
    noLiabilities: "Nessuna passivit\u00E0 trovata.",
    updatePriceDialog: "Aggiorna prezzo",
    debtTermsDialog: "Condizioni del debito",
    urgency: {
      critical: "Critico",
      warning: "Avviso",
      stale: "Obsoleto",
    },
  },

  // Spending category chart
  spendingChart: {
    title: "Spese per categoria",
    selectPeriod: "Seleziona periodo",
    thisMonth: "Questo mese",
    lastMonth: "Mese scorso",
    last3Months: "Ultimi 3 mesi",
    noData: "Nessun dato di spesa per questo periodo.",
  },

  // Portfolio holdings page
  portfolio: {
    title: "Portafoglio investimenti",
    subtitle: "Monitora le performance e l'allocazione del tuo portafoglio di investimenti",
    assets: "Attivi",
    liabilities: "Passivi",
    positionCount_one: "{{count}} posizione",
    positionCount_other: "{{count}} posizioni",
    positionCount: "{{count}} posizioni",
    symbol: "Simbolo",
    qty: "Qt\u00E0",
    price: "Prezzo",
    costBasis: "Costo medio",
    unrealizedPnL: "P&L non realizzato",
    realizedPnL: "P&L realizzato",
    roiPercent: "ROI %",
    totalValue: "Valore totale",
    roiTooltip: "ROI totale = (P&L realizzato + non realizzato) / Totale investito",
    showDebt: "Mostra debiti",
    allAccounts: "Tutti i conti",
    allCountries: "Tutti i paesi",
    noHistoricalData: "Nessun dato storico disponibile per questo periodo.",
    // Holding filter (#131)
    allHoldings: "Tutte le posizioni",
    searchHoldings: "Cerca posizioni…",
    noHoldingsFound: "Nessuna posizione trovata.",
    showClosedPositionsToggle: "Mostra posizioni chiuse",
    closedBadge: "Chiusa",
    closedPositionsGroup: "Posizioni chiuse",
    clearHolding: "Rimuovi filtro posizione",
    showInChart: "Mostra nel grafico",
    holdingNotInAccount: "{{symbol}} non è detenuto in {{account}}",
    noHistoryForHolding: "Nessuno storico per {{name}} in questo periodo",
    holdingPickerLabel: "Filtra il grafico per posizione",
    netWorth: "Patrimonio netto",
    emptyState: "Nessun dato di portafoglio ancora. Collega un conto bancario o importa transazioni per iniziare.",
    connectAccount: "Collega conto",
    importCSV: "Importa CSV",
    errorTitle: "Errore nel caricamento del portafoglio",
    errorDescription: "Si \u00E8 verificato un problema nel recupero dei dati del portafoglio. Riprova pi\u00F9 tardi.",
    liability: "Passivit\u00E0",
    interestRate: "Tasso di interesse",
    term: "Durata",
    balance: "Saldo",
    totalOutstanding: "Totale in sospeso",
    editTerms: "Modifica condizioni",
    addTerms: "Aggiungi condizioni",
    hideClosedPositions_one: "Nascondi {{count}} posizione chiusa",
    hideClosedPositions_other: "Nascondi {{count}} posizioni chiuse",
    hideClosedPositions: "Nascondi {{count}} posizioni chiuse",
    showClosedPositions_one: "Mostra {{count}} posizione chiusa",
    showClosedPositions_other: "Mostra {{count}} posizioni chiuse",
    showClosedPositions: "Mostra {{count}} posizioni chiuse",
  },

  // Tag analytics page
  tagAnalytics: {
    title: "Analisi per tag",
    subtitle: "Analizza le spese per tag su tutti i conti e le valute",
    selectTag: "Seleziona un tag...",
    compare: "Confronta",
    compareWith: "Confronta con...",
    searchTags: "Cerca tag...",
    noTagsFound: "Nessun tag trovato.",
    emptyTitle: "Seleziona un tag per visualizzare le analisi",
    emptyDescription: "Scegli un tag sopra per vedere le ripartizioni di spesa, le tendenze e il monitoraggio del budget",
    totalDebit: "Totale debito",
    totalCredit: "Totale credito",
    balance: "Saldo",
    budgetProgress: "Avanzamento budget",
    topCategory: "Categoria principale",
    categoryBreakdown: "Dettaglio per categoria",
    noSpendingData: "Nessun dato di spesa per questo tag",
    cashFlowTimeline: "Cronologia flusso di cassa",
    noTimelineData: "Nessun dato temporale",
    monthly: "Mensile",
  },

  // Auth page — flat string keys
  "Sign In": "Accedi",
  "Sign Up": "Registrati",
  "Sign in with Google": "Accedi con Google",

  // Auth rejection messages (task #71 — identity hygiene)
  "An account with this email already exists. Sign in with your password instead.": "Esiste già un account con questa email. Accedi con la tua password.",
  "Your Google account's email address is not verified. Verify it with Google, then try again.": "L'indirizzo email del tuo account Google non è verificato. Verificalo con Google e riprova.",
  "Sign-in with Google failed. Please try again.": "Accesso con Google non riuscito. Riprova.",
  "We could not sign you in automatically. Please try signing in with your password.": "Non siamo riusciti ad accedere automaticamente. Prova ad accedere con la tua password.",

  // Invite-only sign-up (task #99)
  "This Bliss instance is invite-only. Use the email address you were invited with.": "Questa istanza di Bliss è solo su invito. Usa l'indirizzo email con cui sei stato invitato.",
  "This email hasn't been invited to this Bliss instance. Ask the person who runs it for an invite.": "Questa email non è stata invitata su questa istanza di Bliss. Chiedi un invito a chi la gestisce.",
  "Sign up with Google": "Registrati con Google",
  "or continue with email": "o continua con l'email",
  "Email address": "Indirizzo email",
  "Password": "Password",
  "Signing in...": "Accesso in corso...",
  "Login failed": "Accesso non riuscito",
  "Full name": "Nome completo",
  "Use at least 8 characters, including a number.": "Usa almeno 8 caratteri, incluso un numero.",
  "By creating an account you agree to our": "Creando un account accetti i nostri",
  "and": "e",
  "Registration failed": "Registrazione non riuscita",
  "Creating account...": "Creazione account...",
  "Create Account": "Crea account",
  "Don't have an account?": "Non hai un account?",
  "Create one": "Creane uno",
  "Already have an account?": "Hai già un account?",
  "Sign in": "Accedi",
  "Welcome to the Bliss demo. Use the credentials below to sign in and explore.": "Benvenuto nella demo di Bliss. Usa le credenziali qui sotto per accedere ed esplorare.",
  "The quiet intelligence behind your global wealth.": "L'intelligenza silenziosa dietro il tuo patrimonio globale.",
  "Financial clarity, without borders.": "Chiarezza finanziaria, senza confini.",
  "Bliss capybara in a turtleneck, seated in a mid-century chair beside a stack of currency coins": "Capibara Bliss con dolcevita, seduto su una sedia mid-century accanto a monete",
  "Bliss capybara mascot seated in a mid-century chair": "Mascotte capibara Bliss seduta su una sedia mid-century",
  "Welcome back": "Bentornato",
  "Protected by enterprise-grade encryption.": "Protetto da crittografia di livello enterprise.",

  // Dashboard actions — flat string keys
  "Fix Bank Connection": "Correggi connessione bancaria",
  "A bank connection needs your attention": "Una connessione bancaria richiede la tua attenzione",
  "Review Pending Transactions": "Revisiona transazioni in sospeso",
  "Check and categorize imported transactions": "Controlla e categorizza le transazioni importate",
  "Update Asset Prices": "Aggiorna prezzi degli asset",
  "Some manual assets need a price refresh": "Alcuni asset manuali necessitano di un aggiornamento del prezzo",
  "Connect your bank": "Collega la tua banca",
  "Plaid (US, CA, UK) or Enable Banking (EU) for automatic sync": "Plaid (USA, CA, Regno Unito) o Enable Banking (UE) per la sincronizzazione automatica",
  "Add Manual Account": "Aggiungi conto manuale",
  "Manually track an account or asset": "Traccia manualmente un conto o asset",
  "Import Transactions": "Importa transazioni",
  "Upload a CSV file to import transactions": "Carica un file CSV per importare transazioni",
  "View Insights": "Visualizza insight",
  "See AI-generated financial observations": "Vedi osservazioni finanziarie generate dall'IA",
  "Explore Expenses": "Esplora spese",
  "See how your spending breaks down": "Scopri come si distribuiscono le tue spese",
  "View Financial Summary": "Visualizza Riepilogo Finanziario",
  "View income vs expenses over time": "Visualizza entrate vs spese nel tempo",
  "View Accounts": "Visualizza conti",
  "See all your connected accounts": "Vedi tutti i tuoi conti collegati",

  // Setup checklist — flat string keys
  "Get started with Bliss": "Inizia con Bliss",
  "of": "di",
  "complete": "completato",
  "Dismiss": "Chiudi",
  // ─── Subscriptions / recurring charges ───────────────────────────────────────
  subscriptions: {
    title: "Abbonamenti",
    subtitle: "Addebiti ricorrenti rilevati sui tuoi conti.",
    scanNow: "Analizza ora",
    scanCooldownShort: "Analisi tra {{count}} min",
    scanStarted: "Analisi avviata",
    scanStartedHint: "Il rilevamento è in esecuzione in background. I risultati compaiono a breve.",
    scanCooldown: "Analisi in pausa",
    scanCooldownHint: "Potrai eseguire un’altra analisi tra circa {{count}} minuti.",
    actionFailed: "L'azione non è riuscita",
    fullScanHintPrefix: "Alcuni abbonamenti annuali datati potrebbero mancare —",
    fullScanHintLink: "esegui una scansione dell'intera cronologia",
    fullScanHintSuffix: " in Impostazioni → Manutenzione.",
    loadError: "Impossibile caricare gli abbonamenti.",
    uncategorized: "Senza categoria",
    toggleCharges: "Mostra i singoli addebiti",
    noCharges: "Nessun addebito trovato per questo esercente.",
    fxUnavailable: "Cambio non disponibile",
    occurrences_one: "{{count}} addebito",
    occurrences_other: "{{count}} addebiti",
    confirm: "Conferma",
    confirmed: "Contrassegnato come abbonamento",
    notASubscription: "Non è un abbonamento",
    dismissed: "Rimosso dagli abbonamenti",
    remove: "Rimuovi",
    removed: "Rimosso",
    restore: "Ripristina",
    restored: "Ripristinato",
    summary: {
      monthly: "Mensile",
      annual: "Annualizzato",
      count: "Abbonamenti attivi",
      fxExcluded: "{{count}} esclusi (nessun tasso di cambio)",
    },
    filter: {
      active: "Attivi",
      lapsed: "Scaduti",
      all: "Tutti",
      allCategories: "Tutte le categorie",
    },
    empty: {
      title: "Ancora nessun addebito ricorrente",
      body: "Quando un esercente ti addebita più volte, comparirà qui.",
    },
    status: {
      active: "Attivo",
      lapsed: "Scaduto",
    },
    cadence: {
      WEEKLY: "Settimanale",
      MONTHLY: "Mensile",
      QUARTERLY: "Trimestrale",
      ANNUAL: "Annuale",
      unknown: "Sconosciuta",
    },
    due: {
      today: "in scadenza oggi",
      inDays: "scade tra {{count}} g",
      agoDays: "in ritardo di {{count}} g",
    },
    rename: {
      label: "Rinomina abbonamento",
      renamed: "Abbonamento rinominato",
      custom: "nome personalizzato",
    },
    merge: {
      mergeInto: "Unisci a un altro abbonamento",
      pickTarget: "Scegli un abbonamento…",
      merged: "Abbonamenti uniti",
      unmerge: "Annulla unione",
      unmerged: "Unione annullata",
      tombstoneHint: "Integrato in un altro abbonamento — i suoi addebiti contano per quello.",
      unknownTarget: "un altro abbonamento",
      mergedCountHint_one: "{{count}} unito a un altro — gestisci",
      mergedCountHint_other: "{{count}} uniti ad altri — gestisci",
      targetMissing: "Destinazione dell'unione mancante",
      stale: "Questa unione non ha effetto — annullala e unisci di nuovo.",
      dismissBlocked: "Prima annulla l'unione delle righe integrate in questa.",
    },
    split: {
      splitByAmount: "Dividi per importo — un abbonamento per prezzo",
      split: "Diviso in un abbonamento per importo",
      unsplit: "Annulla divisione",
      unsplitDone: "Divisione annullata",
      markerHint: "Diviso per importo — ogni prezzo ricorrente è un abbonamento a sé.",
      nothingToSplit: "Questi addebiti non si ripetono con due o più importi diversi.",
    },
    pager: {
      prev: "Precedente",
      next: "Successiva",
      pageOf: "Pagina {{page}} di {{total}}",
    },
  },

  // Passive Income (#77)
  passiveIncome: {
    title: "Reddito passivo",
    subtitle: "Dividendi, cedole, affitti, interessi e sussidi previsti accanto a quanto hai effettivamente ricevuto",
    loadFailed: "Impossibile caricare il reddito passivo.",
    horizon: "Orizzonte di proiezione",
    months_one: "{{count}} mese",
    months_other: "{{count}} mesi",
    kpi: {
      next12m: "Prossimi 12 mesi",
      split: "{{investment}} investimenti · {{other}} altri",
      monthlyAverage: "Media mensile",
      yieldOnValue: "Rendimento sul valore",
      yieldHint: "Solo reddito da investimenti",
      essentialsCoverage: "Spese essenziali coperte",
      essentialsHint: "su {{amount}} spesi negli ultimi 12 mesi",
      noEssentials: "Nessuna spesa essenziale registrata",
      dataCoverage: "Copertura dei dati",
      dataCoverageValue: "{{configured}} su {{total}}",
      dataCoverageHint: "posizioni che generano reddito configurate",
    },
    chart: {
      title: "Reddito effettivo vs previsto",
      actual: "Effettivo",
      today: "Oggi",
    },
    bucket: {
      dividend: "Dividendi",
      coupon: "Cedole",
      rent: "Affitti",
      interest: "Interessi",
      other: "Assegni e sussidi",
    },
    frequency: {
      WEEKLY: "Settimanale",
      MONTHLY: "Mensile",
      QUARTERLY: "Trimestrale",
      SEMIANNUAL: "Semestrale",
      ANNUAL: "Annuale",
      AT_MATURITY: "A scadenza",
      IRREGULAR: "Irregolare",
      MIXED: "Mista",
      NONE: "Nessun pagamento",
    },
    incomeType: {
      DIVIDEND: "Dividendo",
      FIXED_COUPON: "Obbligazione a tasso fisso",
      FLOATING_COUPON: "Obbligazione a tasso variabile",
      INFLATION_LINKED: "Obbligazione indicizzata all'inflazione",
      RENT: "Affitto",
      INTEREST: "Interessi",
      CUSTOM_YIELD: "Rendimento",
      FIXED_AMOUNT: "Importo fisso",
      NONE: "Nessun reddito",
    },
    source: {
      AUTO: "Automatico",
      OVERRIDE: "Personalizzato",
      MANUAL: "Manuale",
      MISSING: "Mancante",
      MIXED: "Misto",
    },
    status: {
      OK: "OK",
      MATURED_UNREDEEMED: "Scaduto: registra il rimborso",
      ENDED: "Terminato",
      STALE_RATE: "Il tasso potrebbe non essere aggiornato",
    },
    yearly: {
      title: "Riepilogo annuale",
      source: "Fonte",
      year: "Anno {{n}}",
      total: "Totale",
    },
    upcoming: {
      title: "Prossimi pagamenti",
      empty: "Nessun pagamento previsto per ora.",
    },
    breakdown: {
      filters: {
        all: "Tutto",
        assets: "Posizioni",
        streams: "Flussi",
        attention: "Da verificare",
      },
      search: "Cerca posizioni o flussi",
      filter: "Filtra",
      noMatches: "Nessun risultato per la ricerca.",
      showing: "{{from}}–{{to}} di {{total}}",
      prev: "Pagina precedente",
      next: "Pagina successiva",
      title: "Dettaglio per posizione o flusso",
      description: "Previsto per i prossimi {{count}} mesi",
      empty: "Nessun reddito configurato. Aggiungi condizioni di reddito alle tue posizioni o un flusso di reddito.",
      holding: "Posizione / flusso",
      type: "Tipo",
      rateOrAmount: "Tasso / importo",
      frequency: "Frequenza",
      nextPayment: "Prossimo pagamento",
      endDate: "Termina",
      horizonTotal: "Previsto",
      mixed: "Misto",
      accounts_one: "{{count}} conto",
      accounts_other: "{{count}} conti",
      showAccounts_one: "Mostra {{count}} conto",
      showAccounts_other: "Mostra {{count}} conti",
      hideAccounts: "Nascondi conti",
      editGroup: "Modifica le condizioni di reddito di tutte le posizioni di {{name}}",
      cashSummary: "Saldo {{balance}} · {{monthly}}/mese",
      quantity: "{{value}} unità",
      view: {
        label: "Vista del dettaglio",
        grouped: "Per titolo",
        flat: "Per conto",
      },
    },
    ladder: {
      title: "Scala delle scadenze",
      description: "Capitale rimborsato per anno (non conteggiato come reddito)",
      empty: "Nessuna obbligazione scade in questo orizzonte.",
    },
    streams: {
      title: "Altri flussi di reddito",
      description: "Assegni e sussidi pubblici non legati a un'attività",
      add: "Aggiungi flusso",
      empty: "Nessun flusso di reddito per ora.",
      noCategories: "Crea una categoria Assegno o Sussidi pubblici nel gruppo Reddito passivo per aggiungere flussi.",
    },
    missing: {
      showAll: "Mostra tutte ({{count}})",
      showLess: "Mostra meno",
      title_one: "{{count}} posizione non ha dati di reddito",
      title_other: "{{count}} posizioni non hanno dati di reddito",
      description: "Aggiungi le condizioni di reddito o segnale come senza distribuzione per completare la proiezione.",
    },
    detached: {
      searchAsset: "Cerca posizioni…",
      noAssets: "Nessuna posizione senza condizioni di reddito.",
      title: "Condizioni di reddito scollegate",
      description: "Queste condizioni appartenevano a posizioni ricreate dopo un'importazione corretta. Ricollegale alla posizione giusta o eliminale.",
      unnamed: "Posizione senza nome",
      detachedOn: "scollegato il {{date}}",
      reattach: "Ricollega",
      discard: "Elimina",
      pickAsset: "Scegli una posizione",
      confirmAttach: "Collega",
      attached: "Condizioni di reddito ricollegate",
      attachFailed: "Impossibile ricollegare le condizioni di reddito.",
      discardTitle: "Eliminare queste condizioni di reddito?",
      discardConfirm: "Verranno eliminate definitivamente.",
      discarded: "Condizioni di reddito eliminate",
      discardFailed: "Impossibile eliminare le condizioni di reddito.",
    },
  },
  incomeTerms: {
    faceValueHint_one: "{{units}} unità detenuta · {{perUnit}} per unità",
    faceValueHint_other: "{{units}} unità detenute · {{perUnit}} per unità",
    pickDate: "Scegli una data",
    clearDate: "Cancella data",
    action: "Condizioni di reddito",
    actionConfigured: "Condizioni di reddito (configurate)",
    title: "Condizioni di reddito — {{name}}",
    addStreamTitle: "Aggiungi flusso di reddito",
    editStreamTitle: "Modifica flusso di reddito",
    assetDescription: "Indica a Bliss quanto paga questa posizione per proiettare il tuo reddito passivo. Importi lordi.",
    streamDescription: "Un reddito ricorrente non legato a un'attività, come un assegno o una pensione pubblica.",
    notIncomeCapable: "Questa posizione non può generare reddito passivo.",
    autoTitle: "Dati automatici sui dividendi",
    autoSummary: "{{count}} pagamenti negli ultimi 12 mesi ({{frequency}}) · {{amount}} per azione · ultimo stacco {{date}}",
    autoNone: "Nessun dividendo negli ultimi 12 mesi (es. un fondo ad accumulazione). Proietta zero e non viene segnalato come mancante.",
    autoUnavailable: "Nessun dato affidabile sui dividendi. Aggiungi un valore personalizzato qui sotto.",
    override: "Sostituisci i dividendi automatici",
    notDistributing: "Non distribuisce reddito",
    groupTitle_one: "Condizioni di reddito — {{name}} ({{count}} conto)",
    groupTitle_other: "Condizioni di reddito — {{name}} ({{count}} conti)",
    applyToAllHoldings_one: "Applica a tutte le posizioni di {{symbol}} ({{count}})",
    applyToAllHoldings_other: "Applica alle {{count}} posizioni di {{symbol}}",
    appliesToHoldings_one: "Si applica a {{count}} posizione di {{symbol}}",
    appliesToHoldings_other: "Si applica a {{count}} posizioni di {{symbol}}",
    mixedTitle: "Queste posizioni non hanno le stesse condizioni",
    mixedDescription: "Ogni conto di {{symbol}} ha ora i propri dati di reddito. Scegli un conto da cui partire.",
    mixedAccount: "Conto",
    mixedUseSame: "Usa le stesse condizioni per tutti",
    mixedEditOne: "Modifica solo questo conto",
    removeFromAllConfirm_one: "Le condizioni di reddito saranno rimosse da {{count}} posizione di {{symbol}}. Azioni ed ETF tornano ai dati automatici.",
    removeFromAllConfirm_other: "Le condizioni di reddito saranno rimosse dalle {{count}} posizioni di {{symbol}}. Azioni ed ETF tornano ai dati automatici.",
    faceValuePerUnitGroupHint_one: "{{units}} unità in {{count}} posizione · {{total}} in totale",
    faceValuePerUnitGroupHint_other: "{{units}} unità in {{count}} posizioni · {{total}} in totale",
    select: "Seleziona…",
    none: "Nessuno",
    otherIndex: "Altro",
    namePlaceholder: "es. Pensione statale",
    netRentHint: "Inserisci l'affitto che ti resta davvero dopo spese e sfitto.",
    previewAnnual: "≈ {{amount}} / anno",
    previewNext: "prossimo pagamento {{date}}",
    previewEnds: "termina nel {{year}}",
    removeTerms: "Rimuovi condizioni",
    deleteStream: "Elimina flusso",
    saved: "Condizioni di reddito salvate",
    deleted: "Condizioni di reddito rimosse",
    saveFailed: "Impossibile salvare le condizioni di reddito.",
    issuer: {
      GOVERNMENT: "Governo",
      CORPORATE: "Societario",
    },
    fields: {
      faceValueTotal: "Valore nominale totale",
      incomeType: "Tipo di reddito",
      issuerType: "Emittente",
      faceValuePerUnit: "Valore nominale per unità",
      couponRate: "Tasso cedolare",
      realCoupon: "Cedola reale",
      referenceIndex: "Indice di riferimento",
      assumedIndexRate: "Tasso ipotizzato dell'indice",
      spread: "Spread",
      frequency: "Frequenza",
      maturityDate: "Data di scadenza",
      anchorPaymentDate: "Una data di pagamento",
      monthlyRent: "Affitto mensile netto",
      annualIndexationPct: "Indicizzazione annua",
      leaseStart: "Inizio del contratto",
      leaseEndDate: "Fine del contratto",
      apyPct: "Rendimento annuo",
      yieldPct: "Rendimento",
      orYieldPct: "…o rendimento",
      dividendPerUnit: "Dividendo annuo per azione",
      name: "Nome",
      category: "Categoria",
      amountPerPayment: "Importo per pagamento",
      currency: "Valuta",
      startDate: "Data di inizio",
      endDate: "Data di fine",
    },
    errors: {
      required: "Obbligatorio",
      invalid: "Valore non valido",
      number: "Inserisci un numero",
      negative: "Non può essere negativo",
      date: "Inserisci una data valida",
      endBeforeStart: "Deve essere successiva alla data di inizio",
      currency: "Usa un codice di 3 lettere (es. EUR)",
    },
  },
  maintenance: {
    fullRebuildSecuritiesStep: "Aggiorna anche i dati dei titoli delle tue azioni ed ETF con dati mancanti o non aggiornati.",
    securityData: {
      title: "Aggiorna i dati dei miei titoli",
      description: "Recupera di nuovo profilo, dividendi e quotazioni di tutte le azioni ed ETF che possiedi (utili solo per le azioni). Usalo se il calendario dei dividendi o l'analisi azionaria sembrano errati.",
      button: "Aggiorna titoli",
    },
    globalFundamentals: {
      title: "Aggiorna i fondamentali di tutti i simboli (globale)",
      description: "Aggiorna la tabella SecurityMaster condivisa per tutti i simboli di tutti i tenant, non solo i tuoi. Più pesante dell'aggiornamento dei tuoi titoli; usalo dopo un incidente del fornitore dati.",
    },
  },

  // Manage Assets page (#81)
  manageAssets: {
    title: "Gestisci asset",
    subtitle: "Tutti i tuoi asset e passività in un unico posto: prezzi, termini di reddito, termini del debito e classi di asset.",
    loadFailed: "Impossibile caricare gli asset. Riprova.",
    assetClassHint: "Si applica a tutte le posizioni di {{symbol}}. Scegli Automatico per rimuovere la modifica.",
    searchPlaceholder: "Cerca per simbolo o nome",
    empty: "Nessun asset corrisponde a questi filtri.",
    count: "{{count}} asset",
    count_one: "{{count}} asset",
    count_other: "{{count}} asset",
    loadMore: "Carica altri",
    loadingMore: "Caricamento…",
    columns: {
      assetClass: "Classe di asset",
    },
    filters: {
      type: "Tipo",
      allTypes: "Tutti i tipi",
      account: "Conto",
      allAccounts: "Tutti i conti",
      assetClass: "Classe di asset",
      allAssetClasses: "Tutte le classi",
      includeClosed: "Mostra posizioni chiuse",
      clear: "Cancella filtri",
    },
    status: {
      debtTermsMissing: "Termini del debito mancanti",
      label: "Filtra per stato",
      stale: "Prezzo non aggiornato",
      incomeMissing: "Termini di reddito mancanti",
      dividendOverride: "Dividendo modificato",
      lotMismatch: "Discrepanza nei lotti",
      assetClassOverridden: "Classe di asset modificata",
    },
    chips: {
      noPrice: "Nessun prezzo",
    },
    actions: {
      addIncomeTerms: "Aggiungi termini di reddito",
      addDebtTerms: "Aggiungi termini del debito",
      menu: "Azioni per {{symbol}}",
      price: "Aggiorna prezzo",
      history: "Storico prezzi",
      assetClass: "Classe di asset",
      copyTrading: "Passa a Copy Trading",
    },
    attention: {
      title: "{{count}} elementi richiedono la tua attenzione",
      title_one: "{{count}} elemento richiede la tua attenzione",
      title_other: "{{count}} elementi richiedono la tua attenzione",
      allClear: "Tutto in ordine",
      allClearHint: "I prezzi sono aggiornati e ogni prestito e posizione che genera reddito ha i suoi termini.",
      stale: "Prezzi da aggiornare",
      debtTermsMissing: "Prestiti senza termini",
      incomeMissing: "Termini di reddito mancanti",
      lotMismatch: "Discrepanze nei lotti da verificare",
    },
    sort: {
      label: "Ordina",
      attention: "Prima ciò che richiede attenzione",
      name: "A–Z",
    },
    detached: {
      title: "{{count}} insiemi di termini di reddito sono scollegati",
      title_one: "{{count}} insieme di termini di reddito è scollegato",
      title_other: "{{count}} insiemi di termini di reddito sono scollegati",
      description: "Una ricostruzione del portafoglio non è riuscita ad associarli a una posizione. Ricollegali o eliminali.",
      review: "Esamina",
      hide: "Nascondi",
    },
  },

  // Processing status (#100): header chip, page banners, Settings → Processing
  activity: {
    types: {
      PORTFOLIO_UPDATE: "Aggiornamento portafoglio",
      ANALYTICS_UPDATE: "Aggiornamento analisi",
      BANK_SYNC: "Sincronizzazione banca",
      IMPORT: "Importazione transazioni",
      SECURITY_DATA: "Aggiornamento dati di mercato",
      SUBSCRIPTION_SCAN: "Analisi abbonamenti",
      INSIGHTS: "Generazione insight",
    },
    stages: {
      scheduling: "Pianificazione",
      recalculating_lots: "Ricalcolo dei lotti",
      updating_cash: "Aggiornamento liquidità",
      valuing_assets: "Valutazione degli asset",
      updating_debts: "Aggiornamento debiti",
      updating_analytics: "Aggiornamento analisi",
      fetching_bank: "Recupero transazioni bancarie",
      syncing_copies: "Sincronizzazione delle copie eToro",
      classifying: "Classificazione transazioni",
      processing_file: "Elaborazione file",
      committing: "Salvataggio transazioni",
      refreshing_market_data: "Aggiornamento dati di mercato",
      scanning: "Analisi",
      generating_insights: "Generazione insight",
    },
    triggers: {
      user_change: "La tua modifica",
      bank_sync: "Sincronizzazione bancaria",
      import: "Importazione",
      nightly: "Notturno",
      manual_rebuild: "Ricostruzione",
      agent: "Agente IA",
      auto_refresh: "Aggiornamento automatico",
    },
    states: {
      queued: "In coda",
      running: "In aggiornamento",
      stalled: "Più lento del solito",
      completed: "Completato",
      failed: "Non riuscito",
    },
    chip: {
      queued: "In coda",
      running: "In aggiornamento",
      stalled: "Più lento del solito",
      failed: "Aggiornamento non riuscito",
      ariaLabel: "Stato delle elaborazioni in background",
      title: "Elaborazioni in background",
      empty: "Tutto è aggiornato",
      lastUpdated: "Ultimo aggiornamento {{time}}",
      jobs: "{{count}} attività",
      workerOffline: "Il processo in background è offline. Le attività in coda partiranno al suo ritorno.",
      failedHint: "Errore {{code}}. Gli amministratori vedono i dettagli in Impostazioni → Elaborazioni.",
      pending: "Avvio…",
    },
    banner: {
      queued: "I numeri di questa pagina verranno ricalcolati a breve ({{label}}). Si aggiorneranno automaticamente.",
      running: "I numeri di questa pagina sono in fase di ricalcolo ({{label}}). Si aggiorneranno automaticamente.",
      runningProgress: "I numeri di questa pagina sono in fase di ricalcolo ({{label}}, {{progress}}%). Si aggiorneranno automaticamente.",
      stalled: "Il ricalcolo sta richiedendo più tempo del solito ({{label}}). I numeri potrebbero non essere aggiornati.",
      failed: "L'ultimo aggiornamento dei dati di questa pagina non è riuscito ({{label}}). I numeri potrebbero non essere aggiornati.",
      updated: "Aggiornato {{time}}",
    },
    time: {
      justNow: "adesso",
      underSecond: "< 1 s",
      minutesAgo: "{{count}} min fa",
      hoursAgo: "{{count}} h fa",
      daysAgo: "{{count}} g fa",
      seconds: "{{count}} s",
      minutes: "{{count}} min",
      hours: "{{count}} h",
    },
    processing: {
      title: "Elaborazioni",
      description: "Il lavoro in background sui tuoi dati: cosa è in corso, le ultime 24 ore e le ricostruzioni.",
      liveTitle: "In corso",
      liveEmpty: "Nulla è in corso. I tuoi dati sono aggiornati.",
      recentTitle: "Ultime 24 ore",
      recentEmpty: "Nessuna elaborazione in background nelle ultime 24 ore.",
      rebuildsTitle: "Ricostruzioni recenti",
      unavailable: "Lo stato delle elaborazioni non è disponibile al momento.",
      workerOffline: "Il processo in background è offline. Le attività in coda partiranno al suo ritorno.",
      elapsed: "in corso da {{time}}",
      queuedFor: "in coda da {{time}}",
      took: "durata {{time}}",
      finished: "terminato {{time}}",
      errorCode: "Errore {{code}}",
      steps_one: "{{count}} passaggio",
      steps_other: "{{count}} passaggi",
    },
    notification: {
      failed_one: "{{count}} aggiornamento in background non è riuscito",
      failed_other: "{{count}} aggiornamenti in background non sono riusciti",
    },
    maintenance: {
      seeProgress: "Vedi avanzamento",
      seeProgressHint: "L'avanzamento in tempo reale e lo storico delle ricostruzioni sono in Elaborazioni.",
    },
  },

  // Enable Banking (#132)
  // eToro copy trading (#143)
  etoro: {
    section: {
      title: "Copy trading eToro",
      description: "Segui il valore e la composizione delle tue copie eToro. Bliss le legge con una chiave di sola lettura del tuo account eToro. Non opera mai e non crea mai transazioni.",
      connect: "Collega eToro",
      empty: "Nessun account eToro collegato.",
      guide: "Come creare una chiave di lettura",
      loadFailed: "Impossibile caricare i collegamenti eToro.",
    },
    status: {
      ACTIVE: "Collegato",
      NEEDS_RECONNECT: "Serve una nuova chiave",
    },
    connection: {
      account: "Conto Bliss",
      noAccount: "Nessun conto",
      key: "Chiave",
      lastSync: "Ultima sincronizzazione",
      never: "Mai",
      lastSyncFailed: "Ultima sincronizzazione non riuscita ({{code}})",
      syncNow: "Sincronizza ora",
      syncStarted: "Sincronizzazione avviata. I valori si aggiorneranno tra pochi minuti.",
      cooldown: "Sincronizzato di recente. Riprova tra {{minutes}} min.",
      replaceKey: "Sostituisci chiave",
      remove: "Rimuovi",
      removeTitle: "Rimuovere questo collegamento eToro?",
      removeDescription: "Bliss smette di aggiornare le tue copie. Le posizioni Copy Trading e il loro storico restano.",
      removeConfirm: "Rimuovi",
      removed: "Collegamento eToro rimosso",
      copies: "Copie",
      noCopies: "Nessuna copia su questo account.",
    },
    copy: {
      closed: "Chiusa su eToro",
      linkedTo: "Collegata a {{symbol}}",
      notLinked: "Non collegata",
      notLinkedHint: "Registra questa copia come posizione Copy Trading con il ticker {{username}} in questo conto, oppure passa un fondo esistente a Copy Trading in Gestisci asset.",
      startedAt: "Dal {{date}}",
    },
    dialog: {
      title: "Collega eToro",
      replaceTitle: "Sostituisci la chiave eToro",
      description: "Crea una chiave di lettura in eToro (Impostazioni → Trading → Gestione chiavi API) e incolla entrambi i valori. Bliss rifiuta le chiavi che possono operare.",
      apiKey: "Chiave API",
      userKey: "Chiave utente",
      userKeyHint: "Salvata cifrata e mai più mostrata.",
      account: "Conto Bliss",
      accountHint: "Il conto in cui registri le tue copie eToro.",
      accountPlaceholder: "Scegli un conto",
      submit: "Collega",
      replaceSubmit: "Salva chiave",
      checking: "Verifica con eToro…",
      successTitle: "Collegato come {{username}}",
      successCopies_one: "{{count}} copia trovata",
      successCopies_other: "{{count}} copie trovate",
      noCopies: "Nessuna copia su questo account.",
      done: "Fatto",
      cancel: "Annulla",
    },
    errors: {
      ETORO_WRITE_SCOPE: "Questa chiave può operare. Crea una chiave di lettura in eToro e usa quella.",
      ETORO_KEY_INVALID: "eToro non ha accettato questa chiave. Controlla entrambi i valori e che non sia scaduta.",
      ETORO_UNAVAILABLE: "Impossibile raggiungere eToro. Riprova più tardi.",
      ETORO_RATE_LIMITED: "eToro sta limitando le richieste. Riprova tra un minuto.",
      ETORO_ALREADY_CONNECTED: "Questo account eToro è già collegato.",
      ETORO_DIFFERENT_LOGIN: "Questa chiave appartiene a un altro account eToro.",
      KEYS_REQUIRED: "Inserisci entrambe le chiavi.",
      ACCOUNT_REQUIRED: "Scegli un conto Bliss.",
      generic: "Qualcosa è andato storto. Riprova.",
    },
    badge: {
      linked: "Collegata a eToro",
      needsReconnect: "La chiave eToro va sostituita",
      closed: "Copia chiusa su eToro",
      notLinked: "Non collegata a eToro",
      lastValue: "Valore eToro del {{date}}",
    },
    convert: {
      title: "Passa a Copy Trading",
      description: "Sposta {{symbol}} nella categoria Copy Trading. Transazioni, condizioni di reddito e storico restano invariati. Una volta collegato l'account eToro, Bliss segue il valore e la composizione della copia.",
      username: "Username eToro dell'investitore che copi",
      usernamePlaceholder: "@investitore",
      pickCopy: "Scegli la copia",
      otherInvestor: "Un altro investitore",
      matched: "corrisponde al nome",
      otherAccount: "La tua connessione eToro usa il conto {{account}}. Questo asset è in un altro conto, quindi non verrà collegato dopo il passaggio: sposta prima le sue transazioni su {{account}}.",
      submit: "Passa",
      success: "{{symbol}} ora è una posizione Copy Trading",
      errors: {
        INVALID_USERNAME: "Inserisci uno username eToro valido.",
        COPY_HOLDING_EXISTS: "Questo conto ha già una posizione per quell'investitore.",
        COPY_TRADING_CATEGORY_MISSING: "Manca la categoria Copy Trading. Chiedi al tuo amministratore Bliss di aggiungerla.",
        generic: "Impossibile modificare questa posizione. Riprova.",
      },
    },
  },
  enableBanking: {
    connect: {
      button: "Collega banca UE (Enable Banking)",
      title: "Collega una banca europea",
      description: "Scegli la tua banca. Verrai portato sul suo sito per approvare l'accesso in sola lettura tramite Enable Banking.",
      search: "Cerca banche",
      loading: "Caricamento banche...",
      loadFailed: "Impossibile caricare l'elenco delle banche. Riprova più tardi.",
      noBanks: "Nessuna banca trovata per i paesi del tuo spazio.",
      startDate: "Le transazioni verranno importate a partire dal",
      consentDays_one: "L'accesso dura fino a {{count}} giorno, poi dovrai ricollegarti.",
      consentDays_other: "L'accesso dura fino a {{count}} giorni, poi dovrai ricollegarti.",
      continue: "Continua verso la banca",
      redirecting: "Reindirizzamento...",
      errorCountryNotEnabled: "Il paese di questa banca non è abilitato per il tuo spazio.",
      errorUnknownBank: "Questa banca non è più disponibile. Scegline un'altra.",
      errorGeneric: "Impossibile avviare il collegamento bancario. Riprova più tardi.",
    },
    callback: {
      reconnectedTitle: "Ricollegata — sincronizzazione in corso",
      reconnectedDesc: "L'accesso alla tua banca è stato rinnovato ed è iniziata una sincronizzazione.",
      errorTitle: "Collegamento bancario non riuscito",
      invalid_state: "Il link di collegamento è scaduto o è già stato usato. Ricomincia da Conti.",
      denied: "L'accesso non è stato concesso dalla tua banca. Nulla è stato collegato.",
      exchange_failed: "La tua banca non ha confermato il collegamento. Riprova tra qualche minuto.",
      not_enabled: "Enable Banking non è configurato per il tuo spazio. Un amministratore può aggiungerlo in Impostazioni → Sincronizzazione bancaria.",
      unknown: "Si è verificato un problema durante il collegamento della banca.",
    },
    mapping: {
      title: "Collega i tuoi conti bancari",
      description: "Scegli in quale conto Bliss si sincronizza ogni conto di {{bank}}.",
      loading: "Caricamento conti...",
      loadFailed: "Impossibile caricare questo collegamento. Riprova più tardi.",
      unnamed: "Conto bancario",
      balance: "Saldo {{amount}}",
      syncInto: "Sincronizza in",
      existingAccounts: "Conti esistenti",
      createNew: "Crea nuovo conto",
      dontSync: "Non sincronizzare",
      linkedPlaid: "sincronizzato tramite Plaid",
      linkedEnableBanking: "sincronizzato tramite un altro collegamento",
      switchHint: "Questo conto è sincronizzato da un altro collegamento. Collegandolo qui la sincronizzazione passa a questa banca; lo storico viene mantenuto.",
      conflict: "Già sincronizzato tramite il collegamento di un'altra persona — autorizza un conto cointestato con un solo titolare.",
      newName: "Nome del conto",
      newBank: "Banca",
      newCountry: "Paese",
      newCurrency: "Valuta",
      createBankOption: "Aggiungi \"{{name}}\"",
      noAccounts: "La tua banca non ha restituito alcun conto.",
      submit: "Collega conti",
      submitting: "Collegamento...",
      successTitle: "Conti collegati — sincronizzazione in corso",
      successDesc_one: "Verrà sincronizzato {{count}} conto. La prima sincronizzazione è iniziata.",
      successDesc_other: "Verranno sincronizzati {{count}} conti. La prima sincronizzazione è iniziata.",
      successNoneDesc: "Nessun conto è stato collegato. Puoi collegarli più tardi da questo collegamento.",
      errorAlreadyConnected: "Uno di questi conti bancari è già sincronizzato tramite un altro collegamento.",
      errorDuplicate: "Due conti bancari non possono sincronizzarsi nello stesso conto Bliss.",
      errorCreateIncomplete: "Compila nome, banca, paese e valuta di ogni nuovo conto.",
      errorGeneric: "Impossibile collegare i conti. Riprova.",
      switchTitle: "Cambiare il fornitore di sincronizzazione?",
      switchDesc: "Questi conti smetteranno di sincronizzarsi con il fornitore attuale e si sincronizzeranno tramite Enable Banking. Lo storico esistente viene mantenuto.",
      switchFrom: "Attualmente sincronizzato tramite {{provider}} ({{bank}})",
      switchConfirm: "Cambia e collega",
      providerPlaid: "Plaid",
      providerEnableBanking: "Enable Banking",
    },
    card: {
      title: "Collegamento Enable Banking",
      statusActive: "Attivo",
      statusExpiring: "In scadenza",
      statusExpired: "Scaduto",
      statusError: "Errore",
      statusDisconnected: "Scollegato",
      statusNeedsMapping: "Da collegare",
      expiringDesc: "L'accesso alla banca sta per terminare. Ricollegati per continuare a sincronizzare.",
      expiredDesc: "L'accesso alla banca è terminato. Ricollegati per riprendere la sincronizzazione.",
      errorDesc: "L'ultima sincronizzazione non è riuscita. Riprova più tardi o ricollegati.",
      needsMappingDesc: "Scegli quali conti Bliss alimenta questa banca prima di poter sincronizzare.",
      bank: "Banca",
      accessExpires: "Scadenza accesso",
      expiresIn_one: "{{date}} (manca {{count}} giorno)",
      expiresIn_other: "{{date}} (mancano {{count}} giorni)",
      lastSync: "Ultima sincronizzazione",
      balanceAsOf: "al {{date}}",
      syncNow: "Sincronizza ora",
      syncStarted: "Sincronizzazione avviata",
      syncStartedDesc: "Le nuove transazioni appariranno a breve.",
      syncFailed: "Impossibile avviare la sincronizzazione",
      syncNotActive: "Ricollega questa banca prima di sincronizzare.",
      syncNoAccounts: "Collega almeno un conto prima di sincronizzare.",
      budgetTitle: "Limite giornaliero di aggiornamenti raggiunto",
      budgetDesc: "La tua banca consente solo pochi aggiornamenti al giorno. Potrai sincronizzare di nuovo dopo {{time}}.",
      budgetDescNoTime: "La tua banca consente solo pochi aggiornamenti al giorno. Riprova domani.",
      reconnect: "Ricollega",
      reconnectOnlyAuthoriser: "Solo la persona che ha autorizzato questo collegamento può ricollegarlo.",
      reconnectFailed: "Impossibile avviare il ricollegamento. Riprova più tardi.",
      mapAccounts: "Collega conti",
      manageAccounts: "Gestisci conti",
      disconnect: "Scollega",
      disconnecting: "Scollegamento...",
      disconnectOnlyAdmin: "Solo un amministratore o la persona che ha autorizzato questo collegamento può scollegarlo.",
      disconnectTitle: "Scollegare {{bank}}?",
      disconnectDesc: "La sincronizzazione si interrompe e l'accesso alla banca viene revocato. I tuoi conti e il loro storico delle transazioni vengono mantenuti.",
      disconnected: "Banca scollegata",
      disconnectedDesc: "La sincronizzazione si è interrotta. I tuoi conti e lo storico vengono mantenuti.",
      disconnectFailed: "Impossibile scollegare",
      statusPaused: "In pausa",
      pausedDesc: "In pausa: credenziali mancanti.",
      pausedAdminLink: "Configura la sincronizzazione bancaria",
      pausedAskAdmin: "Chiedi a un amministratore di aggiungere le credenziali di Enable Banking.",
    },
    pending: {
      message: "{{bank}} è collegata, ma nessun conto è ancora associato. Scegli quali conti sincronizzare.",
    },
    detail: {
      badge: "Enable Banking",
      deleteBlockedHint: "Scollega prima questo collegamento bancario (usa \"Scollega\" qui sopra) prima di eliminare il conto.",
    },
    credentials: {
      title: "Enable Banking (banche UE)",
      intro: "Sincronizza automaticamente i conti delle banche UE con la tua applicazione Enable Banking. Un'applicazione gratuita può collegare fino a 5 conti.",
      guideLink: "Leggi la guida alla configurazione",
      callbackLabel: "URL di ritorno",
      callbackHint: "Registra questo URL come URL di reindirizzamento nella tua applicazione Enable Banking.",
      copy: "Copia",
      copied: "Copiato",
      appIdLabel: "Id dell'applicazione",
      appIdInvalid: "L'id dell'applicazione è un UUID, come 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      keyLabel: "Chiave privata",
      save: "Salva e verifica",
      saving: "Verifica in corso...",
      cancel: "Annulla",
      statusVERIFIED: "Verificate",
      statusUNVERIFIED: "Non verificate",
      statusINVALID: "Non valide",
      unverifiedDesc: "Non è stato possibile contattare Enable Banking per verificare queste credenziali. Sono salvate; usa Verifica di nuovo per riprovare.",
      invalidDesc: "Enable Banking ha rifiutato queste credenziali. Le sincronizzazioni pianificate sono in pausa finché non le verifichi di nuovo o le sostituisci.",
      callbackMissing: "L'URL di ritorno non è ancora registrato su questa applicazione. I collegamenti bancari non funzioneranno finché non lo sarà.",
      appId: "Id dell'applicazione",
      fingerprint: "Impronta della chiave",
      keyBits: "RSA a {{bits}} bit",
      lastValidated: "Ultima verifica",
      never: "Mai",
      linkedAccounts: "Conti collegati",
      linkedAccountsValue: "{{used}} di {{limit}}",
      activeConnections: "Collegamenti attivi",
      replace: "Sostituisci le credenziali",
      reverify: "Verifica di nuovo",
      remove: "Rimuovi",
      replaceHint: "Per cambiare solo la chiave, mantieni l'id dell'applicazione e carica il nuovo file.",
      savedTitle: "Enable Banking è configurato",
      savedDesc: "Il tuo spazio ora può collegare banche UE da Conti.",
      savedUnverifiedDesc: "Salvate, ma non è stato possibile contattare Enable Banking per verificarle. Usa Verifica di nuovo più tardi.",
      verifiedTitle: "Credenziali verificate",
      stillInvalidTitle: "Enable Banking rifiuta ancora queste credenziali",
      stillUnverifiedTitle: "Non è stato possibile contattare Enable Banking",
      removedTitle: "Credenziali rimosse",
      removedDesc: "I collegamenti restano in pausa finché non vengono aggiunte nuove credenziali.",
      errorINVALID_CREDENTIALS: "Enable Banking ha rifiutato queste credenziali. Controlla che la chiave privata appartenga a questa applicazione.",
      errorSANDBOX_APP: "Questa è un'applicazione sandbox. Crea un'applicazione di produzione in modalità limitata.",
      errorINVALID_APP_ID: "L'id dell'applicazione è un UUID, come 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      errorGeneric: "Impossibile salvare le credenziali. Riprova.",
      loadFailed: "Impossibile caricare le impostazioni di Enable Banking.",
      confirmAppChangeTitle: "Cambiare l'applicazione Enable Banking?",
      confirmAppChangeDesc_one: "{{count}} collegamento smetterà di sincronizzarsi finché non verrà ricollegato. I suoi conti e lo storico vengono mantenuti.",
      confirmAppChangeDesc_other: "{{count}} collegamenti smetteranno di sincronizzarsi finché non verranno ricollegati. I loro conti e lo storico vengono mantenuti.",
      confirmRemoveTitle: "Rimuovere le credenziali di Enable Banking?",
      confirmRemoveDesc_one: "{{count}} collegamento resterà in pausa finché non verranno aggiunte nuove credenziali. Conti, associazioni e transazioni vengono mantenuti.",
      confirmRemoveDesc_other: "{{count}} collegamenti resteranno in pausa finché non verranno aggiunte nuove credenziali. Conti, associazioni e transazioni vengono mantenuti.",
      confirmContinue: "Continua",
      pausedBanner_one: "{{count}} collegamento è in pausa finché non aggiungi le tue credenziali di Enable Banking.",
      pausedBanner_other: "{{count}} collegamenti sono in pausa finché non aggiungi le tue credenziali di Enable Banking.",
      historyTitle: "Cronologia delle modifiche",
      historyEmpty: "Ancora nessuna modifica.",
      historySET: "Impostate",
      historyREPLACED: "Sostituite",
      historyKEY_ROTATED: "Chiave cambiata",
      historyREMOVED: "Rimosse",
      historyBy: "da {{name}}",
      historyUnknownUser: "un ex membro",
      notification: "Le credenziali di Enable Banking richiedono attenzione",
      setupLink: "Configura la sincronizzazione delle banche UE",
    },
    keyInput: {
      drop: "Trascina qui il file .pem di Enable Banking",
      choose: "Scegli file",
      pasteInstead: "Incolla invece",
      uploadInstead: "Carica un file invece",
      pasteLabel: "Chiave privata (PEM)",
      valid: "Chiave privata RSA valida · {{bits}} bit",
      clear: "Rimuovi",
      readFailed: "Impossibile leggere questo file.",
      errorKEY_NOT_PEM: "Non è una chiave privata PEM.",
      errorKEY_PUBLIC: "È una chiave pubblica. Usa la chiave privata (.pem) fornita da Enable Banking.",
      errorKEY_CERTIFICATE: "È un certificato, non una chiave privata.",
      errorKEY_NOT_RSA: "Sono supportate solo chiavi private RSA.",
      errorKEY_ENCRYPTED: "Le chiavi protette da password non sono supportate. Usa il .pem non cifrato di Enable Banking.",
      errorKEY_TRUNCATED: "La chiave sembra incompleta: manca la riga END o il testo è stato tagliato.",
      errorKEY_TOO_LARGE: "Supera i 16 KB, troppo per una chiave privata.",
      errorKEY_TOO_SMALL: "Le chiavi RSA devono avere almeno 2048 bit.",
    },
    settings: {
      historyDaysHint: "Vale anche per i collegamenti Enable Banking.",
    },
  },
  // Installable PWA (#155)
  pwa: {
    install: {
      button: "Installa l'app",
      settingsTitle: "App di Bliss",
      settingsDescription: "Installa Bliss per aprirlo in una finestra tutta sua, dalla schermata Home, dal Dock o dalla barra delle applicazioni.",
      bannerTitle: "Installa l'app di Bliss",
      bannerDescription: "Apri Bliss in una finestra tutta sua, dalla schermata Home, dal Dock o dalla barra delle applicazioni.",
      dismiss: "Ignora",
      iosTitle: "Aggiungi Bliss alla schermata Home",
      iosStep1: "Tocca il pulsante Condividi nella barra del browser.",
      iosStep2: "Scorri verso il basso e tocca «Aggiungi alla schermata Home».",
      iosStep3: "Tocca «Aggiungi». Bliss compare nella schermata Home.",
      iosSignInNote: "L'app non condivide l'accesso del browser, quindi accedi una volta dentro l'app.",
      done: "Ho capito",
    },
    update: {
      reload: "Ricarica",
    },
    banks: {
      desktopOnly: "Collega e ricollega le banche da un browser desktop. Le transazioni sincronizzate si possono comunque rivedere qui.",
    },
    offline: {
      title: "Sei offline",
      description: "Bliss ha bisogno di una connessione per mostrare i tuoi dati. I tuoi numeri si ricaricano appena torni online.",
      retry: "Riprova",
    },
  },
  // Onboarding wizard (#154): every step, namespaced
  onboarding: {
    welcome: {
      title: "Benvenuto in",
      subtitle: "Personalizziamo la tua esperienza",
      countries: "I tuoi paesi",
      currencies: "Le tue valute",
    },
    connect: {
      title: "Collega i tuoi conti",
      subtitle: "Collega una banca per la sincronizzazione automatica, importa un foglio di calcolo o aggiungi conti manualmente",
      bankTitle: "Collega la tua banca",
      bankDescription: "Scegli il fornitore che copre la tua banca. Potrai aggiungere l'altro in seguito.",
      learnMore: "Scopri di più",
      plaid: {
        title: "Plaid — banche di Stati Uniti, Canada e Regno Unito",
        description: "Collega in sicurezza i tuoi conti bancari tramite Plaid per sincronizzare automaticamente le transazioni.",
        button: "Collega conto bancario",
        notConfigured: "Plaid non è configurato su questo server.",
        notConfiguredHint: "L'amministratore del server aggiunge le chiavi Plaid; la guida spiega come.",
        error: "Impossibile raggiungere Plaid, riprova più tardi.",
      },
      enableBanking: {
        title: "Enable Banking — banche dell'UE",
        description: "Collega banche dell'UE tramite consenso PSD2, con la tua applicazione Enable Banking.",
        connect: "Collega banca dell'UE",
        setup: "Configura la sincronizzazione delle banche dell'UE",
        adminOnly: "Un amministratore dello spazio di lavoro può configurare la sincronizzazione delle banche dell'UE nelle Impostazioni.",
      },
      setup: {
        title: "Configura la sincronizzazione delle banche dell'UE",
        description: "Bliss si collega alle banche dell'UE tramite la tua applicazione Enable Banking. Aggiungi il suo ID e la chiave privata: Bliss li verifica prima di salvarli, poi scegli la tua banca.",
        needTitle: "Cosa ti serve",
        needAccount: "Un account Enable Banking",
        needApp: "Un'applicazione di produzione in modalità limitata",
        needCallback: "L'URL di callback qui sotto registrato su quell'applicazione",
        limit: "La modalità limitata collega fino a 5 tuoi conti bancari.",
        guide: "Guida passo passo",
      },
      importTitle: "Importa un foglio di calcolo",
      importDescription: "Carica un file CSV o Excel con le tue transazioni.",
    },
    accounts: {
      title: "Aggiungi le tue banche e i tuoi conti",
      subtitle: "Scegli le banche che usi e aggiungi un conto per ciascuna. Potrai inserire i numeri di conto in seguito.",
      selectBanks: "Seleziona le tue banche",
      addDifferentBank: "Aggiungi un'altra banca",
      bankName: "Nome della banca",
      account: "Conto",
      addAccount: "Aggiungi conto",
      removeAccount: "Rimuovi conto",
      removeBank: "Rimuovi banca",
      bankCap: "Puoi aggiungere fino a {{count}} banche qui; potrai aggiungerne altre in seguito.",
      pickCountry: "Scegli il paese di ogni conto; quello predefinito è {{country}}.",
      createdIn: "I conti verranno creati in {{country}}.",
      skip: "Salta per ora",
      create_one: "Crea {{count}} conto",
      create_other: "Crea {{count}} conti",
    },
    errors: {
      noTenant: "Spazio di lavoro non trovato",
      tenantMissing: "Nome o piano dello spazio di lavoro mancante. Contatta l'assistenza.",
      savePreferences: "Impossibile salvare le tue preferenze. Riprova.",
      noUser: "Impossibile identificare il tuo utente. Riprova.",
      setupAccounts: "Impossibile configurare i tuoi conti. Riprova.",
    },
  },
};

export default it;
